export default {
    admin: {
        title: 'admin',
        superadmin: {
            title: 'Super Admin',
            edit: 'redagować'
        },
        invite: {
            manage: 'Zaproś ambasadorów społeczności',
            resend: 'ponownie',
            resend_success: 'Zaproszenie było urażone',
        },
        events: {
            edit: {
                singular: 'Edytuj wydarzenie',
                plural: 'Edytuj wydarzenia',
            },
            overview: 'wydarzenia',
        },
        organizations: {
            edit: {
                singular: 'Edytuj organizację i markę',
                plural: 'Edytuj organizacje i marki',
            },
            overview: 'organizacje i marki',
        },
        pages: {
            edit: {
                singular: 'Edytuj stronę',
                plural: 'Edytuj strony',
            },
            update: {
                success: 'Zaktualizowano stronę',
                singular: "Strona aktualizacji",
                title: "tytuł",
                content: "treść",
                update_success: "Zaktualizowana strona"
            },
            overview: 'strony',
            title: 'tytuł',
            content: 'treść',
        },
        prices: {
            update: {
                success: 'Ceny zaktualizowane',
                singular: "Zaktualizuj ceny",
                title: "tytuł",
                content: "treść",
                update_success: "ceny zostały pomyślnie zaktualizowane"
            },
            success: 'kup pomyślnie',
        },
        users: {
            edit: {
                singular: 'Edytuj użytkownika',
                plural: 'Edytuj użytkowników',
            },
            active: 'Aktywny',
            passive: 'Pasywny',
            overview: 'użytkownicy',
            impersonate: {
                button: 'Podszywanie',
                loading: 'Ładowanie...',
                error: 'Nie można podszyć się pod tego użytkownika.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Linki zgłoszeniowe',
            intro: 'Linki, dzięki którym organizatorzy zgłaszają wydarzenie bez konta.',
            new: 'Nowy link',
            new_hint: 'Utwórz link, który przekażesz organizatorowi przez WhatsApp lub e-mail.',
            create: 'Utwórz link',
            created: 'Link utworzony',
            search: 'Szukaj',
            copy: 'Kopiuj link',
            withdraw: 'Wycofaj',
            reactivate: 'Aktywuj ponownie',
            no_brand: 'Brak marki',
            empty: 'Brak linków.',
            failed: 'Coś poszło nie tak.',
            has_submissions: 'Przez ten link przyszły już zgłoszenia; wycofaj go zamiast usuwać.',
            delete_confirm: 'Usunąć link {code}?',
            fields: {
                code: 'Kod',
                label: 'Opis',
                label_placeholder: 'np. Salsa Nights Rotterdam',
                brand: 'Marka',
                brand_placeholder: 'Szukaj marki',
                brand_hint: 'Opcjonalnie. Decyduje, do której marki należy zgłoszenie.',
                state: 'Status',
                submissions: 'Zgłoszenia',
                expires_at: 'Wygasa',
                max_submissions: 'Maks. zgłoszeń',
                contact_name: 'Kontakt',
                contact_email: 'Adres e-mail',
            },
            states: {
                all: 'Wszystkie',
                active: 'Aktywny',
                expired: 'Wygasły',
                withdrawn: 'Wycofany',
                full: 'Pełny',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Marka', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Status marki' },

            brand_status: {
                unchecked: 'Jeszcze niesprawdzone',
                unmatched: 'Jeszcze nie na LatinMap',
                unmanaged: 'Istnieje, bez opiekuna',
                review: 'Do sprawdzenia',
                managed: 'Zarządzana',
            },
            match_signal: {
                email: 'dopasowano po e-mailu',
                domain: 'dopasowano po stronie',
                name: 'dopasowano po nazwie',
                name_city: 'dopasowano po nazwie + mieście',
                fuzzy: 'podobna nazwa — sprawdź',
            },
            unlink_brand: 'Odłącz markę',
            organization_unlinked: 'Marka odłączona',
            unlink_confirm: {
                title: 'Odłączyć markę?',
                submit: 'Tak, odłącz',
                body: 'Usunąć powiązanie między "{event}" a marką "{brand}"?',
                note: 'Koncept pozostaje na liście i można go powiązać z inną marką. Nic nie zostaje usunięte.',
            },
            link_confirm: {
                title: 'Połączyć markę?',
                submit: 'Tak, połącz',
                body: 'Połączyć "{event}" z marką "{brand}"? Wydarzenie nadal wymaga osobnego zatwierdzenia.',
                signal: 'Znaleziono:',
                warning_managed: 'Tą marką aktywnie zarządza Professional. Połączenie zebranego wydarzenia może kolidować z jego pracą.',
                warning_review: 'To dopasowanie nie jest pewne. Sprawdź, czy naprawdę chodzi o tę samą markę, zanim połączysz.',
            },
            link_match: 'Połącz tę markę',
            refresh_matches: 'Odśwież dopasowania',
            refresh_matches_help: 'Przelicz ponownie, do których istniejących marek należą zebrani organizatorzy',
            matches_refreshed: 'Dopasowania odświeżone: {certain} pewnych, {possible} do sprawdzenia',
            bulk: {
                selected: 'Zaznaczono: {count}',
                link_matched: 'Połącz dopasowaną markę',
                approve: 'Zatwierdź',
                reject: 'Odrzuć',
                clear: 'Wyczyść zaznaczenie',
                running: 'Trwa...',
                select_all: 'Zaznacz wszystko na tej stronie',
                select_one: 'Zaznacz {name}',
                nothing_to_link: 'Brak pewnego dopasowania w zaznaczeniu',
                nothing_to_unlink: 'Żaden element zaznaczenia nie ma powiązanej marki',
                unlink: 'Odłącz',
                result: '{succeeded} przetworzono, {failed} pominięto',
                confirm: {
                    title: 'Potwierdź akcję zbiorczą',
                    submit: 'Tak, kontynuuj',
                    body_approve: 'Opublikować {count} koncept(ów)? Te bez potwierdzonej lub pewnej marki zostaną pominięte.',
                    body_reject: 'Odrzucić {count} koncept(ów)?',
                    body_unlink: 'Usunąć powiązanie z marką dla {count} koncept(ów)?',
                    unlink_skipped: 'Pominięto {skipped} z zaznaczenia: nie mają powiązanej marki.',
                    body_assign: 'Połączyć {count} koncept(ów) z dopasowaną marką? Wydarzenia nadal wymagają osobnego zatwierdzenia.',
                    assign_skipped: 'Pominięto {skipped} z zaznaczenia: już połączone lub brak pewnego dopasowania.',
                    and_more: 'i jeszcze {count}',
                    assign_managed: '{count} z tych marek jest aktywnie zarządzanych przez Professional. Połączenie może kolidować z ich pracą.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'bliższe dane:',
            reported: 'Zgłoszone przez:',
            suspended_at: 'zawieszony w:',
            email: 'Email:',
            phonenumber: 'numer telefonu',
            message: 'wiadomość:',
            singular: 'raport',
            plural: 'Raporty',
            reportables: {
                event: 'wydarzenia',
                organization: 'organizacje',
            },
            status: {
                submitted: 'Złożony',
                under_review: 'W trakcie przeglądu',
                resolved: 'Rozwiązany',
                no_issue: 'Nie ma problemu',
            },
            reportables_by_type: {
                event: 'wydarzenie',
                organisation: 'organizacje i marki',
                user: "użytkownik",
                created_by: 'stworzone przez',
                report_by: 'Raport przez',
                ip_adress: 'Adres IP',
                reason: 'powód',
                description: 'opis',
                empty: 'pusty',
            },
            no_reports: 'Nie znaleziono raportów',
        },
        lead: {
            singular: 'Ołów',
            plural: {
                event: 'prowadzenie wydarzenia',
                organization: 'Ołów marki'
            }
        },
        block_user: {
            plural: 'blokuj użytkowników',

            title: 'BLOCKED',
            description: 'Your account has been blocked, you don\'t have access to the platform anymore.'
        },
        setting: {
            plural: 'Ustawienia',
            reset: {
                warning: {
                    title: 'Zresetuj wszystkie ustawienia administratora.',
                    body: 'Czy na pewno chcesz zresetować wszystkie ustawienia?'
                }
            }
        },
        permissions: {
            plural: 'uprawnienia',
            levels: {
                'level-1': 'Super admin',
                'level-2': 'admin',
                'level-3': 'ambasador',
                'level-4': 'Członek premium',
                'level-5': 'Profesjonalny członek',
                'level-6': 'członek',
            },
            no_users_with_role: 'Nie ma użytkowników z tym poziomem roli.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'Utwórz organizację w imieniu innego użytkownika',
                'latinmap-verify': 'Grant LatinMap STATION',
                invite: {
                    'level-3': 'Zaproś ambasadorów społeczności',
                },
                reports: {
                    view: 'Zobacz raporty',
                    delete: {
                        any: 'usuń dowolny raport',
                    },
                    update: 'Aktualizacja statusu raportu',
                    export: 'Raporty eksportu',
                },
                events: {
                    create: 'tworzyć wydarzenia',
                    view: 'Zobacz wydarzenia',
                    update: {
                        any: 'Zaktualizuj każde zdarzenie',
                        own: 'Zaktualizuj własne wydarzenia',
                    },
                    delete: {
                        any: 'Usuń każde zdarzenie',
                        own: 'usunąć własne wydarzenia',
                    },
                    publish: 'Publikuj wydarzenia',
                    unpublish: 'Niepublikowane wydarzenia',
                    ownership: {
                        own: 'Zmień własność własnych wydarzeń',
                        any: 'Zmień własność każdego wydarzenia',
                    },
                    ticketshop: {
                        enable: 'Włącz Ticketshop',
                    },
                },
                organisations: {
                    create: 'Twórz organizacje i marki',
                    update: {
                        any: 'Zaktualizuj wszystkie organizacje i marki',
                        own: 'Zaktualizuj własne organizacje i marki',
                    },
                    delete: {
                        any: 'Usuń wszystkie organizacje i marki',
                        own: 'Usuń własne organizacje i marki',
                    },
                    ownership: {
                        own: 'Zmień własność własnych organizacji i marek',
                        any: 'Zmień własność wszelkich organizacji i marek',
                    },
                },
                users: {
                    edit: 'Edytuj użytkowników',
                },
                leads: {
                    view: 'Wyświetl leady',
                    delete: 'Usuń leady',
                },
                transfer_requests: {
                    view: 'Wyświetl żądania transferu',
                    approve: 'zatwierdzić żądania transferu',
                }
            }
        },
        dance_styles: {
            title: 'Style tańca',
            singular: 'Styl tańca',
            create: {
                singular: 'Stwórz styl tańca',
            },
            edit: {
                singular: 'Edytuj styl tańca',
                plural: 'Edytuj style tańca',
            },
            delete: {
                title: 'Usuń styl tańca?',
                singular: 'usuwać',
                cancel: 'anulować',
                confirmation: 'Ten styl tańca ma style substancji tańca.',
                affected: 'Ten styl tańca jest używany w {event_count} Events i {organization_count} organizacje.',
                label: 'Usuń styl tańca',
                placeholder: 'Wpisz tutaj "{keyword}" i prześlij, aby usunąć ten styl tańca.',
            },
            sub_dance_style: 'Styl Sub Dance',
            is_favorite: 'jest ulubionym',
        },
        music_styles: {
            title: 'Style muzyczne',
            singular: 'Styl muzyczny',
            create: {
                singular: 'Stwórz styl muzyki',
            },
            edit: {
                singular: 'Edytuj styl muzyki',
                plural: 'Edytuj style muzyczne',
            },
            delete: {
                title: 'Usuń styl muzyki?',
                singular: 'usuwać',
                cancel: 'anulować',
                confirmation: 'Ten styl muzyczny ma style sub muzyki.',
                affected: 'Ten styl muzyczny jest używany w {event_count} wydarzenia i organizacje {organization_count}.',
                label: 'Usuń styl muzyki',
                placeholder: 'Wpisz tutaj "{keyword}" i prześlij, aby usunąć ten styl muzyczny.',
                substyles: 'Ten styl muzyczny ma style sub-muzyczne.',
            },
            sub_dance_style: 'Styl Sub Dance',
            sub_music_style: 'STYL SUBU MUSI',
            is_favorite: 'jest ulubionym',
        },
        featuredEvent: 'Wydarzenie',
        event_types: {
            edit: {
                plural: 'Edytuj typy zdarzeń',
            }
        },
        brand_types: {
            edit: {
                plural: 'Edytuj typy marki',
            }
        },
        prof_financial_title: 'Centrum finansowe',
        modoration:
        {
            title: 'umiar',
        },
        official_brands: 'offical brands',
        export: {
            overview: {
                title: 'eksport i transfery',
                subtitle: 'Eksportować wszystkie organizacje, dla każdej organizacji zostanie wygenerowany link transferowy.'
            },
            create: 'Utwórz eksport',
            copied_link: 'link skopiowany',
            take_ownership: 'przejąć własność',
            validate_phone: 'Aby przejąć własność tej organizacji, najpierw musisz zweryfikować swój numer telefonu, można to zrobić poniżej:',
            require_login: 'Aby przejąć własność tej organizacji, najpierw musisz się zalogować lub utworzyć konto, można to zrobić poniżej:',
            to_login: 'To login',
            messages: {
                opened: 'Twój link do transferu został pomyślnie aktywowany, masz 30 dni na ukończenie procesu.',
                continue: 'Twój link do transferu został pomyślnie ponownie otwarty, proszę zakończyć proces transferu.',
                no_key: 'Nie podano żadnego klucza, może się to zdarzyć, jeśli odświeżyłeś stronę, powinieneś ponownie otworzyć oryginalny link.',
                not_exists: 'Obecnie nie ma linku do transferu dla tej organizacji.',
                unauthorized: "Nie masz uprawnień do zaakceptowania tego transferu organizacji.",
                expired: 'Ten link wygasł.',
                already_completed: 'This link has already been completed and can no longer be used.',
                transferred: 'Organizacja została pomyślnie przeniesiona.'
            },
            warning: {
                title: 'Usuń link transferowy',
                body: 'Czy na pewno chcesz usunąć ten link do transferu?'
            },
            status: {
                no_action: 'nie przeniesione',
                opened: 'otwierany',
                completed: 'przeniesiony',
                expired: 'wygasły'
            }
        },
        duplications: 'duplikacje',
        suspend_toggle: {
            warning: {
                title: 'Przełącz zawieszenie',
                body: 'Czy na pewno chcesz zmienić zawieszenie tego?'
            }
        },
        take_offline: {
            warning: {
                title: 'zdejmij offline',
                body: 'Czy na pewno chcesz wziąć to offline, nie będzie już widoczny dla użytkowników.'
            }
        },
        bring_online: {
            warning: {
                title: 'Mettre en ligne',
                body: 'Êtes-vous sûr de vouloir mettre cela en ligne? Cela sera visible pour les utilisateurs.'
            }
        },
        'carousel-image': {
            plural: "Obrazy karuzeli",
            overview: {
                title: "Obrazy karuzeli",
                subtitle: "Zarządzaj obrazami karuzeli na stronie głównej."
            },
            create: {
                singular: "Utwórz obraz karuzeli",
                success: "Obraz karuzeli został pomyślnie utworzony",
                error: "Błąd podczas tworzenia obrazu karuzeli"
            },
            delete: {
                success: "Obraz karuzeli został pomyślnie usunięty",
                error: "Błąd podczas usuwania obrazu karuzeli"
            },
            image: "Obraz",
            visibility: 'Widoczne sekundy',
            title: "Tytuł",
            order_by: "Sortuj według",
            warning: {
                body: "Czy na pewno chcesz usunąć ten obraz karuzeli? Tej operacji nie można cofnąć.",
                title: "Usuń obraz karuzeli"
            },
        },
        'beta-feature': {
            plural: 'Funkcje beta',
            overview: {
                title: 'Funkcje beta',
                subtitle: 'Zarządzaj funkcjami beta na stronie głównej.',
                success: 'Funkcja beta została pomyślnie zaktualizowana',
                error: 'Błąd podczas aktualizacji funkcji beta',
            },
            key: 'Klucz',
            name: 'Nazwa',
            description: 'Opis',
            visible_to_admins: 'Widoczne dla administratorów',
            visible_to_users: 'Widoczne dla użytkowników',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Zakład Latin',
            options: {
                all_events: 'Wszystkie Wydarzenia',
                latin_festivals_and_congresses: 'Latin Festiwale i Kongresy',
                latin_parties_and_socials: 'Partie i Towarzyskie'
            }
        },
        dance_schools: {
            label: 'Latin Szkoły Tańca',
            options: {
                dance_schools: 'Szkoły Tańca',
                try_outs_and_start_courses: 'Wypróbuj i Rozpocznij Kursy',
                workshops_and_bootcamps: 'Warsztaty i Bootcamps',
                about_the_latin_dance_scene: 'O Scenie Latin'
            }
        },
        community: {
            label: 'Społeczność Latin',
            options: {
                teachers: 'Nauczycielstwo',
                show_performers_and_teams: 'Pokaż Wykonawców i Zespołów',
                djs: 'DJ',
                live_bands: 'Zespoły/Muzyka na żywo',
                media_photo_video: 'Media, Zdjęcie, Wideo',
                mcs: 'MC'
            }
        },
        dancewear_and_shoes: {
            label: 'Latin Odzież Taneczna i Buty',
            options: {
                dancewear_and_shoes: 'Odzież Taneczna i Buty'
            }
        },
        for_professionals: {
            label: 'Dla Profesjonalistów',
            options: {
                create_a_brand: 'Jak Stworzyć Markę',
                create_an_event: 'Jak Utworzyć Wydarzenie',
                promote_your_event: 'Jak Promować Swoje Wydarzenie',
                professional_account_verification: 'Weryfikacja Konta Profesjonalnego'
            }
        },
        join: {
            label: 'Dołącz do LatinMap',
            options: {
                create_a_brand_or_organization: 'Utwórz Markę lub Organizację',
                become_an_ambassador: 'Zostań Ambasadorem'
            }
        },
        manage_and_promote: {
            label: 'Zarządzaj i Promuj',
            options: {
                my_events: 'Moje Wydarzenia',
                promote_your_event: 'Promuj Swoje Wydarzenie'
            }
        }
    },
    impersonation: {
        banner: 'Przeglądasz jako {name}',
        stop: 'Przestań podszywać się',
    },
    menu_headers: {
        general_title: 'ogólny',
        orders_title: 'Moje zamówienia',
        settings_title: 'Ustawienia',
        professional_title: 'profesjonalny',
        prof_financial_title: 'moje centrum finansowe',
        special_access_title: 'specjalny dostęp',
        community_dashboard_title: 'mój ambasador pulpitu społecznościowego',
        session_title: 'sesja',
    },
    account: {
        owned_by_organization: 'Należy do organizacji {organization_name}',
        organization_settings_title: 'Ustawienia Organizacji',
        selected_organization: 'Wybrana organizacja',
        my_events: 'Moje wydarzenia',
        role: 'Rola',
        dashboard: "panel",
        default_filters: "Moje wyszukiwania",
        login: "login",
        logout: "Logout",
        sign_in: "zalogować się",
        sign_up: "zapisać się",
        email_address: "adres e-mail",
        password: "hasło",
        password_repeat: "Powtórz hasło",
        password_reset: "resetować hasło",
        password_forgot: "Zapomniane hasło",
        reset_password: "Zresetuj hasło",
        current_password: "bieżące hasło",
        change_password: "Zmień hasło",
        new_password: "nowe hasło",
        password_reset_success: "Zresetuj hasło",
        forgot_password: "Zapomniałem hasła",
        not_a_member: "nie członek",
        i_already_have_an_account: "Mam już konto",
        i_accept_the: "Akceptuję",
        terms_and_conditions: "Warunki",
        first_name: "imię",
        last_name: "nazwisko",
        postal_code: "kod pocztowy",
        street_number: "numer ulicy",
        city: "miasto",
        country: "kraj",
        preferred_language: "Preferowany język",
        date_of_birth: "data urodzenia",
        create: "Utwórz konto",
        my_account: "moje konto",
        my_professional_dashboard: "mój profesjonalny pulpit nawigacyjny",
        ambassador_dashboard: "Pulpit nawigacyjny ambasadora",
        my_organisations: "Moje organizacje i marki",
        my_organisations_description: "Zarządzaj swoimi organizacjami i markami",
        singular: "konto",
        phone: "numer telefonu",
        phone_verification_token: "Token weryfikacji telefonu",
        name: "nazwa",
        user_name: "nazwa użytkownika",
        resend_verification: "ponownie weryfikacja",
        update_error: 'Aktualizacja konta nie powiodła się.',
        myLatinmap: "Moja LatinMap",
        dancerprofile: "Mój profil tancerza",
        orders: 'Moje zamówienia',
        phone_verification: 'Weryfikacja telefonu',
        submitted_leads: 'Moje przesłane potencjalne potencjalne potencjalne klienty',
        settings: 'Ustawienia',
        switch: 'Przełącz na markę/organizację',
        beta_features: 'Funkcje beta',
        gender: {
            singular: "płeć",
            male: "Mężczyzna",
            female: "Kobieta",
            other: "Inny",
        },
        profile: {
            title: 'profil',
            description: 'Zarządzaj informacjami o swoim profilu, zmień hasło i więcej.',
        },
        remove: {
            label: 'Usuń konto',
            placeholder: 'Type "delete" here and submit to remove your account.',
            admin_placeholder: 'Type "delete" here and submit to remove this account.',
            safeword: 'usuwać',
            description: 'To usunie Twoje konto i wszystkie powiązane dane.',
        },
        favorites: {
            title: 'ulubione',
            description: 'Twoje ulubione wydarzenia, szkoły taneczne itp.',
            no_favorites: 'nie masz jeszcze ulubionych w tej kategorii',
            plurals: {
                event: 'wydarzenia',
                dancer: 'tancerze',
                dj: 'DJ',
                media: 'głoska bezdźwięczna',
                brand: 'Buty taneczne, ubrania, sklep',
                school: 'Szkoły taneczne',
                venue: 'miejsca',
                club: "klub",
                teacher: "nauczyciel",
                show_performers_and_teams: "Pokaż wykonawców i zespołów",
                performer: "wykonawca",
                mc: "MC",
                latin_music: "Muzyka łacińska",
                event_organizer: "Organizator wydarzeń",
                organization: 'organizacje i marki',
            },
        },
        likes: {
            title: 'upodobania',
            description: 'Twoje lubiane wydarzenia, szkoły taneczne itp.',
            no_likes: 'Nie masz jeszcze polubień w tej kategorii',
            plurals: {
                event: 'wydarzenia',
                dancer: 'tancerze',
                dj: 'DJ',
                media: 'Media (photo, video, video editing)',
                brand: 'Buty taneczne, ubrania, sklep',
                school: 'Szkoły taneczne',
                venue: 'miejsca',
                club: "klub",
                teacher: "nauczyciel",
                show_performers_and_teams: "Pokaż wykonawców i zespołów",
                performer: "wykonawca",
                mc: "MC",
                latin_music: "Muzyka łacińska",
                event_organizer: "Organizator wydarzeń",
                organization: 'organizacje i marki',
            },
        },
        verification: {
            phone: {
                description: "Potrzebna jest weryfikacja telefonu, aby zapewnić bezpieczeństwo i autentyczność użytkowników uzyskujących dostęp do „profesjonalnego” pulpitu nawigacyjnego.",
                not_verified: 'Twój numer telefonu nie jest weryfikowany.',
                send_verification_text: 'Wyślij tekst weryfikacyjny',
                sent: 'Wysłany tekst weryfikacyjny',
                verified: 'Twój numer telefonu jest weryfikowany.',
                verify: 'Sprawdź numer telefonu',
            },
        },

    },
    dashboard: {
        title: "Dashboard",
        welcome: "Witamy",
    },
    organizations: {
        organization_saved: 'Organizacja uratowana',
        containing_emoji_error: 'Emoji\'s są niedozwolone w nazwie. Użyj znaków alfanumerycznych lub dozwolonych znaków specjalnych.',
        invalid_character_error: 'W nazwie jest nieprawidłowy znak. Użyj znaków alfanumerycznych lub dozwolonych znaków specjalnych.\nNieprawidłowe znaki:',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'Wszystko',
                    },
                    organization_type: {
                        all: 'Wszystko',
                        dance_schools: 'Szkoły taneczne',
                        organizers: 'Organizatorzy',
                        artists: 'Nauczyciele i wykonawcy',
                        disk_jockeys: 'DJ',
                    }
                }
            },
            no_results: {
                title: 'Nie znaleziono organizacji',
                subtitle: 'Żadne organizacje nie znaleziono dla wybranych filtrów.'
            },
        },
        transfers: {
            overview: {
                title: 'transfery',
                subtitle: 'Zarządzaj własnością swoich organizacji',
                incoming_transfers: 'Nadchodzące transfery',
                outgoing_transfers: 'transfery wychodzące',
                request: 'wniosek',
                offer: 'oferta',
                event: 'wydarzenie',
                organization: 'organizacja',
            },
            status: {
                approved: 'przeniesienie zaakceptowane',
                pending: 'aż do',
                rejected: 'transfer spadł'
            },
            create: {
                title: 'Własność transferu',
                organization: 'organizacja',
                description: 'Przenieś własność swojej organizacji do innego użytkownika.',
                reason: 'powód',
                transfer_to: 'Transfer do (e -mail)',
                transfer: 'przenosić',
                warning: 'Gdy tylko przeniesienie zostanie zaakceptowane, własność organizacji zostanie przeniesiona do nowego właściciela.',
            }
        },
        remove: {
            label: 'Usuń Organizację',
            description: 'Trwale usuń tę organizację i wszystkie powiązane dane.',
            success: 'Organizacja została pomyślnie usunięta',
            error: 'Nie udało się usunąć organizacji'
        },
        transactions: {
            overview: {
                title: 'transakcje',
                subtitle: 'Zarządzaj transakcjami swoich organizacji i marek',
            }
        },
        create: 'Utwórz organizację',
        is_public_options: {
            private: 'prywatny',
            public: 'publiczny',
            private_warning: 'Twoja organizacja nie jest widoczna online z tym statusem.'
        },
        offline_preview: 'Ta organizacja jest offline i widoczna tylko jako podgląd.',
    },
    organization: {
        accepts_posts_on_behalf: 'Pozwól LatinMap dodawać nasze wydarzenia',
        accepts_posts_on_behalf_help: 'Gdy nasza marka jest nieaktywna, LatinMap może dodawać publicznie ogłoszone wydarzenia pod naszą nazwą. Są wyraźnie oznaczone i w każdej chwili możesz je edytować lub usunąć.',
        'on-behalf-of': 'w imieniu',
        'on-behalf': {
            none: 'Wybierz opcję',
            me: 'Ja, reprezentuję tę markę',
            other: 'Jako przedstawiciel marki',
            noone: 'Jako ambasador LatinMap',
        },
        featured: {
            title: 'Polecane szkoły taneczne',
            subtitle: 'Niektóre z wyróżnionych, najwyżej ocenianych akademii tanecznych z kursami tanecznymi.',
        },
        my_favorites: {
            title: 'moje ulubione',
        },
        edit: {
            public_information: 'informacja',
            customers: 'klienci',
            events: 'wydarzenia',
            tickets: 'Bilety',
            authorized_person: 'upoważnione osoby',
        },
        organization_detail: {
            involved: 'zaangażowany',
            verification_status: {
                verified: 'zweryfikowane',
                not_verified: 'jeszcze nie zweryfikowane',
            }
        },
        account: {
            title: "konto",
            description: "Zarządzaj informacjami o swoim koncie dla profesjonalnego pulpitu nawigacyjnego.",
            description_not_verified: "Sprawdź numer telefonu, aby korzystać z profesjonalnego pulpitu nawigacyjnego.",
        },
        transfer: {
            title: 'Własność transferu',
            description: 'Czy chcesz poprosić o własność tej organizacji?',
            what: 'Co jest oferowane?',
            submit: 'Prześlij żądanie',
            name: 'nazwa',
            location: 'lokalizacja',
            email: 'e-mail',
            reason: 'powód',
            organization: 'Organizacja i marka',
            errors: {
                nameRequired: 'Nazwa jest wymagana.',
                emailRequired: 'Wymagany jest e -mail.',
                reasonRequired: 'Powód jest wymagany.'
            },
            succesfully_sent: 'żądanie przeniesienia zostało pomyślnie wysłane.',
            error_occurred: 'coś poszło nie tak.',
            noOrganisation: 'Nie masz jeszcze żadnych organizacji.'
        },
        title: "organizacja",
        is_public: 'jest publiczny',
        publicly_visible: 'Publicznie widoczne',
        change_organization: "Zmień organizację",
        create: "Utwórz organizację",
        name: "nazwa",
        name_without_dj: "Nazwa (bez 'dj')",
        dj_name_tooltip: "Wprowadź tylko nazwę. 'DJ' zostanie dodany automatycznie",
        email: "e-mail",
        phone: "numer telefonu",
        phone_verification_token: "Token weryfikacji telefonu",
        country: "kraj",
        city: "miasto",
        street: "ulica",
        street_number: "numer ulicy",
        postal_code: "kod pocztowy",
        type: "Type",
        question: "Twoja organizacja?",
        types: {
            event: 'Wydarzenie',
            dancer: "tancerz",
            latin_music: "Muzyka łacińska",
            performer: "wykonawca",
            teacher: "nauczyciel",
            show_performers_and_teams: "Pokaż wykonawców i zespołów",
            dj: "DJ",
            mc: "MC",
            media: "Media (zdjęcie, wideo, edycja wideo)",
            brand: "Buty taneczne, ubrania, sklep",
            event_organizer: "Organizator wydarzeń",
            school: "Szkoła taneczna",
            live_music: "Zespół/muzyka na żywo",
            venue: "lokal",
        },
        short_description: "Krótki opis",
        long_description: "Długi opis",
        photos: "Zdjęcia",
        dance_styles: "Style tańca",
        music_styles: "Style muzyczne",
        my_brands: "Moje marki",
        my_brands_description: "Zarządzaj swoimi markami",
        overview: {
            title: 'Szkoły taneczne',
            subtitle: 'Znajdź najlepsze szkoły taneczne w Twojej okolicy.',
            filters: {
                organization_name: 'Nazwa organizacji',
                dance_styles: 'Style tańca',
                postal_code: 'kod pocztowy',
                nearby_range: 'pobliskie zasięg sugestii kodu pocztowego',
                nearby: 'pobliskie sugestie',
                location: 'Gdzie',
                favorites: 'ulubione',
                country_codes: 'Kody krajowe',
                music_styles: 'Style muzyczne',
                ambassadors: 'Ambasadorzy',
                slidertooltip: '<p><strong> Suwak zasięgu dostosowuje cyfry wprowadzonego kodu pocztowego, aby rozszerzyć obszar wyszukiwania. </strong><p> Każdy krok zwiększa kod pocztowy o 100. </p><p> Na przykład, o godz.',
            },
            organizers: {
                title: 'Organizatorzy',
                subtitle: 'Znajdź najlepszych organizatorów w Twojej okolicy.',
            },
            artists: {
                title: 'Nauczyciele i wykonawcy',
                subtitle: 'Znajdź najlepszych artystów w Twojej okolicy.',
            },
            dance_schools: {
                title: 'Szkoły taneczne',
                subtitle: 'Znajdź najlepsze szkoły taneczne w Twojej okolicy.',
            },
            disk_jockeys: {
                title: 'DJ',
                subtitle: 'Znajdź najlepszych DJ-ów w swojej okolicy. Ciesz się najlepszymi wydarzeniami i festiwalami.',
            },
            show_performers_and_teams: {
                title: 'Pokaż wykonawców i zespołów',
                subtitle: 'Znajdź najlepszych wykonawców w Twojej okolicy.',
            },
            teacher: {
                title: 'nauczycielstwo',
                subtitle: 'Znajdź najlepszych nauczycieli w Twojej okolicy.',
            },
            mcs: {
                title: "MC",
                subtitle: 'Znajdź najlepsze MC w Twojej okolicy.',
            },
            live_music: {
                title: "Zespoły/muzyka na żywo",
                subtitle: 'Znajdź najlepsze zespoły na żywo i muzykę w Twojej okolicy.',
            },
            live_performer: {
                title: "Wykonawca na żywo",
                subtitle: 'Znajdź najlepszych wykonawców na żywo w Twojej okolicy.',
            },
            performer: {
                title: "wykonawca",
                subtitle:
                    "Znajdź najlepszych wykonawców na żywo w swojej okolicy. Ciesz się najlepszymi wydarzeniami i festiwalami."
            },
            media: {
                title: "Media (zdjęcie, wideo, edycja wideo)",
                subtitle: 'Znajdź najlepszych fotografów i kamerzyści w Twojej okolicy.',
            },
            brand: {
                title: "Buty taneczne, ubrania, sklep",
                subtitle: 'Znajdź najlepsze buty taneczne i ubrania w Twojej okolicy.',
            },
        },
        artists: {
            title: 'Nauczyciele i wykonawcy',
        },
        teacher: {
            title: 'nauczycielstwo',
        },
        performer: {
            title: 'wykonawcy'
        },
        show_performers_and_teams: {
            title: 'Pokaż wykonawców i zespołów',
        },
        dance_schools: {
            title: 'Szkoły taneczne',
        },
        disk_jockeys: {
            title: 'DJ',
        },
        organizers: {
            title: 'Organizatorzy',
        },
        manage_authorized_people: {
            title: 'Zarządzaj upoważnionymi osobami',
            description: 'Zarządzaj upoważnionymi osobami w organizacjach, których jesteś właścicielem. Upoważnione osoby mogą zarządzać Twoją organizacją i wydarzeniami.'
        },
        authorized_people: {
            title: 'Upoważnione osoby',
            description: 'Zarządzaj upoważnionymi osobami Twoich organizacji. Upoważnione osoby mogą zarządzać Twoją organizacją i wydarzeniami.',
            create: 'Utwórz upoważnioną osobę',
            edit: 'Edytuj upoważnioną osobę',
            overview: 'Upoważnione osoby',
            not_found: 'Nie znaleziono upoważnionych osób',
        },
        mcs: {
            title: "MC",
        },
        live_music: {
            title: "Zespoły/muzyka na żywo",
        },
        live_performer: {
            title: "Wykonawcy na żywo",
        },
        media: {
            title: "Media (zdjęcie, wideo, edycja wideo)",
        },
        brand: {
            title: "Buty taneczne, ubrania, sklep",
        },
        email_authorized: 'Wprowadź istniejący adres e -mail.',
    },
    ambassador: {
        profile: "profil",
        my_brands: "Moje marki",
        verification: {
            phone: {
                description: "Potrzebna jest weryfikacja telefonu, aby zapewnić bezpieczeństwo i autentyczność użytkowników uzyskujących dostęp do pulpitu nawigacyjnego „ambasadora”."
            }
        }
    },
    brands: {
        create: "Stwórz markę",
        brand_saved: "Zapisana marka",
        change_brand: "Zmień markę",
        edit: {
            authorized_person: "upoważnione osoby"
        },
        posted_by_ambassador_text: 'Ta marka została stworzona przez ambasadora LatinMap, zaufanego członka społeczności, który przyczynia się do zawartości platformy.',
    },
    contact: {
        title: "kontakt",
        name: "nazwa",
        email: "e-mail",
        message: "wiadomość",
        subject: "temat",
        send: "wysłać",
        success: "wiadomość wysłana",
        error: "Nie można wysłać wiadomości",
    },
    ticketstore: {
        select_amount: 'Wybierz kwotę biletu',
        your_information: 'Twoje informacje',
        total: 'całkowity',
        next: 'Następny',
        back: 'z powrotem',
        checkout: 'wymeldować się',
        tickets_for: 'Bilety na',
        ticket_types: 'typy biletów',
        ticket: {
            starts_at: 'zaczyna się od',
            location: 'lokalizacja',
            name: 'nazwa',
            description: 'opis',
            tickets_sold: 'Bilety sprzedane',
            actions: 'działania',
            available: 'dostępny',
            total_available: 'Łącznie dostępne',
            price: 'cena',
            create: 'Utwórz typ biletu',
            edit: 'Edytuj typ biletu',
            success: 'Twój typ biletu został pomyślnie przesłany.',
            remove_label: 'Usuń typ biletu',
            remove_description: 'To usunie typ biletu i wszystkie powiązane dane.',
        },
    },
    events: {
        select_category: "Wybierz kategorię",
        select_country: "Wybierz kraj",
        select_timezone: "Wybierz strefę czasową",
        select_status: "Wybierz status",
        select_currency: "Wybierz walutę",
        select_brand_error: "Nie wybrano marki",
        title: 'wydarzenia',
        bring_online: 'wprowadzić do sieci',
        take_offline: 'odłączyć od sieci',
        by: 'Wydarzenia {organization_name}',
        create_new: 'Utwórz nowe wydarzenie',
        event_saved: 'Zbawione wydarzenie',
        event_published: 'Twoje wydarzenie jest teraz na żywo i widoczne na stronie wydarzeń.',
        error_saving: 'zdarzenie oszczędzania błędów',
        containing_emoji_error: 'Emoji\'s są niedozwolone w nazwie. Użyj znaków alfanumerycznych lub dozwolonych znaków specjalnych.',
        invalid_character_error: 'W nazwie jest nieprawidłowy znak. Użyj znaków alfanumerycznych lub dozwolonych znaków specjalnych.\nNieprawidłowe znaki:',
        duration_too_long: 'Czas trwania tego wydarzenia jest zbyt długi, maksymalna liczba dni, w których wydarzenie może wziąć udział, to: ',
        error_updating_ticket_type: 'Wystąpił błąd podczas zapisywania typu biletu.',
        ticket_type_updated: 'Typ biletu został pomyślnie zaktualizowany.',
        posted_by_ambassador: 'Wysłane przez Ambasador Latinmap',
        posted_by_ambassador_text: 'To wydarzenie zostało stworzone przez ambasadora LatinMap, zaufanego członka społeczności, który przyczynia się do zawartości platformy.',
        posted_on_behalf_text: 'LatinMap dodał to wydarzenie na podstawie publicznie dostępnych informacji. Organizator nie zaktualizował jeszcze samodzielnie tych informacji.',
        posted_on_behalf_label: 'dodane przez LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Dodane przez LatinMap',
        not_posted_by_ambassador: 'zweryfikowane przez organizatora',
        participants: {
            create: {
                title: 'Utwórz uczestnika dla "{event_name}"',
                description: 'Utwórz nowego uczestnika wydarzenia "{event_name}"',
                invite: 'Zaproś uczestnika',
                role: 'rola',
            },
            role: {
                performer: 'wykonawca',
                organizer: 'organizator',
            },
            overview: {
                participants: 'Uczestnicy',
            }
        },
        statuses: {
            active: 'aktywny',
            canceled: 'odwołany',
            changed: 'zmienione',
            pending: 'aż do'
        },
        currencies: {
            none: 'Brak waluty',
            euro: 'Euro',
            dollar_american: 'Dolar Amerykański',
            pound_uk: 'Funt Angielski',
            lira_turkish: 'Lira Turecka',
            rupee_indian: 'Rupia Indyjska'
        },
        event_detail: {
            cta_block: {
                title: 'Bilety',
                subtitle: 'Na to wydarzenie dostępne są bilety!',
                button: 'Zdobądź swoje bilety teraz'
            },
            organizer: {
                plural: 'Organizatorzy',
                singular: 'organizator',
                invariable: 'Organizator (y)',
            }
        },
        overview: {
            title: 'wydarzenia',
            nearby_events: 'pobliskie wydarzenia',
            subtitle: 'Zanurz się w rytmicznych uderzeniach, radosnych ruchach i kulturowej fuzji salsy, Bachaty i innych.',
            festival: {
                title: 'Festiwale taneczne i kongresy',
            },
            try_out: {
                title: 'Spróbuj, otwórz dzień, rozpocznij kurs (y)',
            },
            party_social: {
                title: 'Imprezy i Spotkania towarzyskie',
            },
            no_results: {
                title: 'Nie znaleziono żadnych wydarzeń',
                subtitle: 'Nie znaleziono zdarzeń dla wybranych filtrów.'
            },
            filters: {
                event_name: 'Nazwa wydarzenia lub organizacji',
                event_id: 'ID wydarzenia',
                event_category: 'Typ zdarzenia',
                dance_styles: 'Style tańca',
                dance_style: 'Styl tańca',
                music_styles: 'Style muzyczne',
                music_style: 'Styl muzyczny',
                ambassadors: 'Ambasadorzy',
                status: 'status',
                user_name: 'użytkownik',
                user_type: 'Typ użytkownika',
                organization: 'organizacja',
                organization_type: 'Typ organizacji',
                location: 'Gdzie',
                date: 'Kiedy',
                date_from: 'z',
                date_to: 'Do',
                apply_filters: 'Zastosuj filtry',
                clear_filters: 'jasne filtry',
                country_codes: 'Kody krajowe',
                city: 'miasto',
                favorites: 'ulubione',
                postal_code: 'kod pocztowy',
                nearby_range: 'pobliskie zasięg sugestii kodu pocztowego',
                apply: 'stosować',
                sliderinfo: 'Przyrosty 100',
                slidertooltip: '<p><strong> Suwak zasięgu dostosowuje cyfry wprowadzonego kodu pocztowego, aby rozszerzyć obszar wyszukiwania. </strong><p> Każdy krok zwiększa kod pocztowy o 100. </p><p> Na przykład, o godz.',
                option_labels: {
                    date_filter: {
                        upcoming: 'nadchodzące',
                        this_week: 'W tym tygodniu',
                        next_week: 'przyszły tydzień',
                        in_two_weeks: 'Za dwa tygodnie +',
                        this_month: 'w tym miesiącu',
                        specific_dates: 'określone daty',
                        all: 'Wszystko'
                    },
                    favorites: {
                        all: 'Wszystko',
                        favorites: 'Ulubione',
                        likes: 'Pokaż tylko moje lubiane wydarzenia',
                        favorites_likes: 'Pokaż podobały się wydarzenia lub wydarzenia ulubionych marek',
                    },
                    organization_type: {
                        all: 'Wszystko',
                        dance_schools: 'Szkoły taneczne',
                        organizers: 'Organizatorzy',
                        music_styles: 'Style muzyczne',
                        music_style: 'Styl muzyczny',
                        artists: 'Nauczyciele i wykonawcy',
                        disk_jockeys: 'DJ',
                    },
                    user_type: {
                        professional: 'profesjonalny',
                        ambassador: 'ambasador',
                        admin: 'admin',
                        superadmin: 'superadmin'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'Warsztaty i bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'Festiwale i kongresy',
            try_out: 'Spróbuj, otwórz dzień, rozpocznij kurs (y)',
            live_music: 'Zespoły/muzyka na żywo',
            workshop_bootcamp: 'Warsztaty i bootcamps',
        },
        categories: {
            festival: 'Festiwal/Kongres',
            workshop_bootcamp: 'warsztat/bootcamp',
            workshop_bootcamp_party: 'Impreza z warsztatem/bootcamp',
            party_social: 'Partia/Social',
            competition: 'konkurs',
            performance_concert: 'Występ/koncert',
            outdoor_event: 'Wydarzenie na zewnątrz',
            dance_trip: 'podróż taneczna',
            party_live_music: 'Muzyka imprez/na żywo',
            online_event: 'Wydarzenie online',
            try_out: 'Spróbuj, otwórz dzień, rozpocznij kurs (y)',
            show: 'pokazywać',
            marathon: 'maraton',
            weekender: 'Weekender',
            retreat: 'Retreat',
            other: 'Inny',
        },
        create: 'Utwórz wydarzenie',
        edit: 'Edytuj wydarzenie',
        remove: {
            label: 'Usuń zdarzenie',
            description: 'To usunie zdarzenie i wszystkie powiązane dane.',
        },
        brand: 'marka/organizacja',
        name: 'nazwa',
        country: 'kraj',
        city: 'miasto',
        street: 'ulica',
        street_number: 'numer ulicy',
        short_description: 'Krótki opis',
        long_description: 'Długi opis',
        dance_styles: 'Style tańca',
        music_styles: 'Style muzyczne',
        photos: 'Zdjęcia',
        photos_preview_mode: 'Zdjęcia są widoczne po zapisaniu w trybie podglądu',
        preview: 'pokazywać',
        category: 'Typ zdarzenia',
        language: 'język',
        location_type: {
            singular: 'Typ lokalizacji',
            online: 'faktyczny',
            offline: 'osobiście',
        },
        timezone: 'strefa czasowa',
        date: 'data',
        week: 'tydzień',
        start: 'start',
        end: 'koniec',
        location: 'lokalizacja',
        information: 'informacja',
        start_date: 'Data rozpoczęcia',
        start_time: 'czas rozpoczęcia',
        end_date: 'Data zakończenia',
        end_time: 'czas zakończenia',
        ends_at: 'kończy się na',
        registration_opens_at: 'Rejestracja otwiera się na',
        registration_closes_at: 'Rejestracja kończy się',
        is_public: 'Gotowy na żywo?',
        location_name: 'Nazwa miejsca',
        photos_required: 'Wymagane jest co najmniej jedno zdjęcie.',
        tickets_sold: 'Bilety sprzedane',
        actions: 'działania',
        participate: 'brać udział',
        verified: 'Oficjalna marka zweryfikowana',
        undercondition: 'Jeszcze nie potwierdzono',
        warning: 'Ważna zmiana - ostatnia aktualizacja:',
        ticket:'Tickets available',
        cancelled: 'anulowane - ostatnia aktualizacja:',
        upcoming: 'Nadchodzące wydarzenia',
        past: 'Wcześniejsze wydarzenia',
        status: 'status',
        status_reason: 'powód statusu',
        entrance: 'Ceny biletów',
        entrance_tooltip: 'Tutaj możesz określić cenę biletu. Wprowadź liczbę, jeśli cena się nie zmienia, na przykład: \'5\'. dla przedziału cenowego możesz określić przedział, na przykład \'5-10\'. Użyj \'free\', jeśli nie ma ceny wejściowej.',
        currency: 'Waluta',
        currency_tooltip: 'Można również określić walutę. Najczęściej używanymi walutami są: euro (€), dolar amerykański ($), funt angielski (£), lira turecka (₺) i rupia indyjska (₹). Jeśli nie wybrano żadnej waluty, można dodać dowolny tekst, np. \'5-12 euro\'.',
        repeat: 'powtórzenia',
        djs: 'DJ',
        dj: 'DJ',
        artists: 'Artyści',
        artist: 'artysta',
        question: "Twoje wydarzenie?",
        status_options: {
            active: 'aktywny',
            canceled: 'odwołany',
            pending: 'Jeszcze nie potwierdzono',
            changed: 'ważna zmiana',
        },
        is_public_options: {
            draft: 'projekt',
            private: 'prywatny',
            public: 'publiczny',
            draft_message: 'Zapisz swoje wydarzenie jako szkic.',
            private_message: 'Twoje wydarzenie będzie widoczne tylko dla użytkowników z dostępem.',
            public_message: 'Opublikuj swoje wydarzenie, aby było widoczne na stronie wydarzeń.',
            private_warning: 'Twoje wydarzenie nie jest widoczne online z tym statusem.'
        },
        legend: {
            title: 'legenda',
            verified: 'Oficjalna marka zweryfikowana',
            not_verified: 'Nie zweryfikowane przez organizację: Organizator nie potwierdził jeszcze działania.',
            cancelled: 'odwołany',
            warning: 'ważna zmiana',
            posted_by: 'Wysłane przez Ambasador Latinmap',
            condition: 'Jeszcze nie potwierdzono',
            ticket:'Tickets available',
            duplicate_event_error: 'wydarzenie z tą nazwą, data rozpoczęcia i data zakończenia już istnieje',
            ticket_order: 'Bilety dostępne, zamów je tutaj!'
        },
        ticket_types: 'typy biletów',
        potential_duplicates: 'możliwe duplikaty',
        proceed_anyway: 'Zapisz pomimo duplikatu',
        duplicate_event_error: 'wydarzenie z tą nazwą, data rozpoczęcia i data zakończenia już istnieje',
        event_deleted: 'zdarzenie usunięte',
        error_deleting_event: 'zdarzenie usuwania błędów',
        featured: {
            title: 'Prezentowane wydarzenia w społeczności',
            subtitle: 'Odkryj i zdobądź bilety na festiwale taneczne, koncerty i wycieczki w najlepszej cenie!',
            badge: 'Wyróżnione',
            view: 'Zobacz wydarzenie',
            title_page: 'Zmień cenę globalną',
            featured_event: "Kup zdarzenie",
            duration_type: "Typ czasu trwania",
            day: "dzień",
            month: "miesiąc",
            year: "rok",
            duration: "czas trwania",
            price: "cena",
            calculate_price: "Oblicz cenę",
            proceed_to_payment: "przejdź do płatności",
            current_price: "Obecna cena",
            no_price_found: "Brak ceny za wybrany czas trwania",
            update_price: "Aktualizacja ceny",
            setFeaturedEvents: "Zestaw wydarzenia",
            fetch_current_price: "przynieść bieżącą cenę",
            update_global_event_price: "Zaktualizuj globalną cenę zdarzenia",
            price_per_day: 'cena dziennie',
            buy: 'Kup zdarzenie',
            duration_label: 'Jak długo chciałbyś prezentować wydarzenie?',
            enter_duration: 'Wybierz czas trwania',
            total_price: 'całkowity',
            yes: "Tak",
            no: "NIE",
            invalid_invoice: 'coś poszło nie tak, spróbuj ponownie',
            download_failed: 'coś poszło nie tak, spróbuj ponownie',
            setFeaturedEvent: 'Set Fontered Event dla:',
            setFeatured: 'Zestaw wydarzenia',
            featured_success: 'Wydarzenie zostało pomyślnie przedstawione.',
            already_featured: 'To wydarzenie jest już polecone',
            featured_error: 'coś poszło nie tak',
            durationError: 'Wartość nie może być mniejsza niż 1'
        },
    },
    blocked_user:{
        create: 'Utwórz zablokowanego użytkownika',
        edit: 'Aktualizacja zablokowana użytkownik',

        blocked_email: 'zablokowany e -mail',
        blocked_phone_number: 'Zablokowany numer telefonu',
        reason: 'powód',

        delete: {
            warning: {
                title: 'Usuń blokowanie użytkowników',
                body: 'Czy na pewno chcesz usunąć ten blok.'
            }
        }
    },
    carousel: {
        title: 'Odkryj taniec latynoamerykański - wydarzenia, szkoły, przesłuchania i wiele więcej w Twojej okolicy!',
        subtitle: 'Znajdź miejsce, w którym możesz tańczyć, uczyć się i nawiązać kontakt ze społecznością latynoską.',
        popular: 'Popularne',
        search: {
            placeholder: 'Wprowadź słowo kluczowe lub miasto, aby zapoznać się z ofertami tańców latynoamerykańskich...',
            button: 'ODKRYĆ',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'Na żywo z parkietu',
            subtitle: 'Najnowsze wpisy z naszego Instagrama — scena taka, jaka jest naprawdę, tydzień po tygodniu.',
            follow: 'Obserwuj {handle}',
            post_alt: 'Wpis {handle} na Instagramie',
        },
        cta_block_1: {
            title: 'Organizujesz imprezy taneczne?',
            subtitle:
                'Jeśli organizujesz imprezy, festiwale, wyjścia, kongresy, weekendy, warsztaty, kursy intensywne i koncerty taneczne, mamy coś dla Ciebie. Promuj swoje wydarzenie, zarządzaj promotorami i sprzedawaj bilety!',
            button: 'Zarejestruj się teraz'
        },
        cta_block_2: {
            title: 'Odkryj Wydarzenia w Twojej Okolicy',
            subtitle:
                'Odkryj wydarzenia i aktywności w Twojej okolicy. Eksploruj i ciesz się doświadczeniami!',
            placeholder: 'Twoja lokalizacja',
            input_button: 'Blisko mnie',
            button: 'Znajdź wydarzenia'
        },
        cta_block_3: {
            button: 'Utwórz Wydarzenie',
        },
        choose_and_live_experiences: 'Wybieraj i przeżywaj doświadczenia',
        experiences: {
            festivals_congresses: "Festiwale i Kongresy",
            parties_socials: "Imprezy i Spotkania towarzyskie",
            try_outs_start_courses: "Lekcje próbne i Kursy początkujące",
            dance_schools: "Szkoły tańca",
            workshops_bootcamps: "Warsztaty i Bootcampy",
            dancewear_shoes: "Odzież i Buty do tańca",
            teachers: "Nauczyciele",
            show_performers_teams: "Artyści i Zespoły pokazowe",
            djs: "DJ-e",
            live_music: "Zespoły na żywo",
            media_photo_video: "Media (Zdjęcia/Wideo)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Rozpocznij swoją podróż z LatinMap',
            subtitle: 'Wybierz, jak chcesz doświadczać LatinMap',
            agenda: {
                title: 'Agenda Światowa',
                sub_header: 'Wolny dostęp',
                subtitle: 'Odkryj globalną scenę tańca latynoskiego',
                description: 'Przeglądaj imprezy, warsztaty, festiwale, lekcje próbne i kursy początkowe - wszystko w jednej agendzie',
                button: 'Zobacz Latin Agenda',
                footer: 'Nie wymaga konta'
            },
            member: {
                title: 'Zostań Członkiem',
                sub_header: 'Darmowe konto',
                subtitle: 'Zbuduj własne doświadczenie LatinMap',
                description: 'Stwórz swoją osobistą LatinMap i pozostań w kontakcie ze sceną tańca latynoskiego — lokalnie i międzynarodowo.',
                features: {
                    agenda: 'Kompletna i aktualna agenda tańca latynoskiego',
                    follow: 'Śledź swoje ulubione wydarzenia, artystów i marki',
                    save: 'Zapisuj ulubione jednym kliknięciem',
                    store: 'Przechowuj swoje wyszukiwania i odkrycia',
                    custom_agenda: 'Twórz własną spersonalizowaną agendę',
                    explore: 'Odkrywaj nowe miasta, style i sceny'
                },
                button: 'Utwórz darmowe konto',
                footer: 'Darmowe dołączenie – nigdy nie przegap wydarzenia'
            },
            professional: {
                title: 'Zostań Profesjonalistą',
                sub_header: 'Darmowy profil profesjonalny',
                subtitle: 'Dla festiwali, szkół tańca, nauczycieli, DJ-ów, muzyków i organizatorów',
                description: 'Zwiększ swoją widoczność, zarządzaj wydarzeniami i docieraj do międzynarodowej społeczności latynoskiej.',
                features: {
                    brand_page: 'Twoja własna profesjonalna strona marki',
                    publish: 'Publikuj i zarządzaj wydarzeniami łatwo',
                    invite: 'Zapraszaj członków zespołu do współpracy',
                    insights: 'Statystyki i narzędzia rozwoju',
                    exposure: 'Międzynarodowa ekspozycja na LatinMap'
                },
                button: 'Aktywuj konto Pro',
                footer: 'Wymaga najpierw konta Członka'
            }
        },
    },
    dropzone: {
        drop_here: 'Upuść pliki tutaj, aby przesłać',
        files_required: "{Count} Wymagane",
        max_filesize: "Maksymalny rozmiar pliku: {max} MB"
    },
    general: {
        select_organization_please: "Proszę wybrać organizację",
        no_organization_selected: "Nie wybrano organizacji",
        all: 'Wszystko',
        styles: 'Style',
        important_information: 'Ważne informacje',
        starts_at: 'z',
        ends_at: 'Do',
        socialmedia_links: 'spinki do mankietów',
        share_with_your_friends: 'Podziel się ze znajomymi',
        link_copied: 'Link skopiowany do schowka!',
        link_copy_failed: 'Nie udało się skopiować linku.',
        hosted_by: 'hostowane przez',
        created_by: 'stworzone przez',
        posted_by: 'Opublikowane przez',
        created: 'stworzony',
        archive: 'archiwum',
        modified: 'zmodyfikowane',
        score: 'wynik',
        reset: 'nastawić',
        unknown: 'nieznany',
        submit: 'składać',
        suggest: 'sugerować',
        other: 'Inny',
        delete: 'usuwać',
        copy_link: 'Kopiuj link',
        back: 'z powrotem',
        show: 'pokazywać',
        duplicate: 'duplikat',
        proceed: 'przystępować',
        cancel: 'anulować',
        accept: 'Przyjąć',
        reject: 'odrzucić',
        show_in_new_window: 'Pokaż w nowym oknie',
        checkout: 'wymeldować się',
        external_link_warning: {
            title: 'Link zewnętrzny',
            content: 'Zamierzasz opuścić tę stronę.',
            question: 'Czy chcesz przejść do następującego adresu URL?',
        },
        add: 'dodać',
        date: 'data',
        search: {
            save_new: 'Zapisz nowe wyszukiwanie',
            instructions: 'Zapisz wyszukiwanie, aby użyć go ponownie później.',
            name: 'nazwa',
            none_stored: 'Nie masz jeszcze zapisanych wyszukiwań.',
            stored: 'Zapisane wyszukiwania',
            events: 'wydarzenia',
            organizations: 'organizacje',
            paginate: 'na stronę',
            page: 'strona',
            view: 'pogląd',
            filters: 'filtry',
            delete: 'usuwać',
            views: {
                grid: 'siatka',
                list: 'lista',
                agenda: 'porządek obrad',
                monthlist: 'Lista miesiąca',
            },
            filter_labels: {
                name: 'nazwa',
                location: 'lokalizacja',
                dance_styles: 'Style tańca',
                music_styles: 'Style muzyczne',
                event_categories: 'Kategorie zdarzeń',
                date_filter: 'data',
                favorites: 'ulubione',
                country_codes: 'Kody krajowe',
                organization_type: 'typy organizacji',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'strona internetowa',
            linkedin: 'LinkedIn',
            youtube: 'YouTube',
            tiktok: 'Tiktok',
            reddit: 'Reddit',
            pinterest: 'Pinterest',
            twitter: 'X',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Wydarzenie na Facebooku',
            whatsapp: 'WhatsApp',
        },
        description: {
            title: 'opis',
            show_more: 'Pokaż więcej',
            show_less: 'pokaż mniej',
        },
        map: 'mapa',
        gmap_block: {
            title: 'mapa',
            location_name: 'Nazwa lokalizacji'
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'wyniki',
            filter: 'filtr',
            open_filter: 'Otwarty filtr',
        },
        edit: 'redagować',
        create: 'tworzyć',
        expand: 'więcej',
        more_info: 'Więcej informacji',
        collapse: 'mniej',
        unique_impressions: 'Unikalne wrażenia',
        close: 'zamknąć',
        save_changes: 'Zapisz zmiany',
        update_changes: 'Zapisz zmiany',
        scrollright: 'Przewiń w prawo, aby uzyskać więcej informacji.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'nawigacja',
        cta: 'Utwórz wydarzenie',
    },
    date: {
        from: 'z',
        to: 'Do',
    },
    report: {
        event: 'zdarzenie raportu',
        organization: 'Organizacja raportu',
        name: 'nazwa',
        location: 'lokalizacja',
        date: 'data',
        success: 'Twój raport został pomyślnie złożony.',
        not_logged_in: 'Wymagane konto',
        tooltip: 'raport',
        status: {
            warning: {
                title: 'Aktualizuj status raportu',
                body: 'Czy na pewno chcesz zmienić status raportu?'
            }
        },
        archive: {
            warning: {
                title: 'raport archiwalny',
                body: 'Czy na pewno chcesz zarchiwizować ten raport? Tego nie można cofnąć.'
            }
        }
    },
    form: {
        save: 'ratować',
        save_and_verify: 'Zapisz i sprawdź',
        too_many_requests: 'Osiągnąłeś limit wiadomości.' +
            'Poczekaj kilka minut zanim wyślesz kolejne żądanie.',
    },
    form_subject: {
        general_inquiry: "Ogólne zapytanie",
        technical_support: "Wsparcie techniczne",
        issue_event_submission: "Problem zgłoszenia zdarzenia",
        issue_account_login: "Konto lub problem logowania",
        question_billing_payment: "Pytanie rozliczeniowe lub płatnicze",
        report_issue: "zgłosić problem",
        suggest_feature: "sugestia cech",
        other: "Inny"
    },
    api: {
        general: {
            validation_error: 'Błąd sprawdzania poprawności',
            permission_denied: 'Zezwolenie odrzucone',
            success: 'sukces',
        },
        auth: {
            unauthorized: 'Nie jesteś upoważniony do dostępu do tego zasobu.',
            blocked: 'Twoje konto zostało zablokowane, nie będziesz w stanie uzyskać dostępu do żadnych funkcji.',
            user_not_found: 'Konto jest zobowiązane do korzystania z tej funkcji, najpierw zrób konto.',
            email_password_unknown: 'Podany adres e -mail lub hasło jest nieprawidłowe.',
            email_unverified: 'Twój adres e -mail nie został zweryfikowany.',
            email_already_verified: 'Twój adres e -mail jest już zweryfikowany.',
            phone_already_verified: 'Twój numer telefonu został już zweryfikowany.',
            phone_already_used: 'Ten numer telefonu jest już używany',
            invalid_verification_link: 'Podany link weryfikacyjny jest nieprawidłowy.',
            email_verified_success: 'Twój adres e -mail został zweryfikowany.',
            verification_email_sent: 'Link weryfikacyjny został wysłany na Twój adres e -mail.',
            login_success: 'Udało ci się zalogować.',
            logout_success: 'Z powodzeniem się wylogowałeś.',
            registration_success: 'Udało Ci się zarejestrować.',
            failed: 'Te poświadczenia nie pasują do naszych rekordów.',
            password: 'Podane hasło jest nieprawidłowe.',
            throttle: 'Zbyt wiele prób logowania.',
            user_updated_success: 'Twoje konto zostało pomyślnie zaktualizowane.',
            old_password_incorrect: 'Podane stare hasło jest nieprawidłowe.',
            password_changed_success: 'Twoje hasło zostało pomyślnie zmienione.',
            user_deleted_success: 'Twoje konto zostało pomyślnie usunięte.',
            verification_text_sent: 'Tekst weryfikacyjny został wysłany na Twój numer telefonu.',
            invite_invalid: 'Używany adres URL zaproszenia jest nieprawidłowy.',
            too_many_requests: 'Zbyt wiele próśb.',
            day_limit_exceeded: 'Przekroczyłeś dziś maksymalną liczbę żądań dotyczących tej funkcji.'
        },
        organization: {
            created_success: 'Organizacja została pomyślnie utworzona.',
            authorized_person: {
                created: 'Upoważniona osoba została pomyślnie utworzona.',
                updated: 'Upoważniona osoba została pomyślnie zaktualizowana.',
                removed: 'Upoważniona osoba została pomyślnie usunięta.',
                not_found: 'Nie można było znaleźć upoważnionej osoby.',
                already_exists: 'upoważniona osoba już istnieje.',
                role: {
                    singular: 'rola',
                    invalid: 'Dostarczona rola jest nieprawidłowa.',
                    eventPublisher: 'Wydawca wydarzenia',
                    eventCreator: 'Stwórca wydarzeń',
                    authorizedPerson: 'upoważniona osoba',
                }
            },
        },
        event: {
            created_success: 'Wydarzenie zostało pomyślnie utworzone.',
            deleted_success: 'Wydarzenie zostało pomyślnie usunięte.',
        },
        report: {
            created_success: 'Raport został pomyślnie utworzony.',
            invalid_type: 'Podany typ raportu jest nieprawidłowy.',
        },
        user: {
            updated_success: 'Użytkownik został pomyślnie zaktualizowany.',
            search_filter: {
                created: 'stworzony',
            }
        },
        upload: {
            created_success: 'Przesłanie zostało pomyślnie utworzone.',
            deleted_success: 'Przesłanie zostało pomyślnie usunięte.',
        },
        forms: {
            submitted_success: 'Formularz został złożony pomyślnie.',
        },
        passwords: {
            reset: 'Twoje hasło zostało zresetowane.',
            sent: 'Wysłaliśmy wiadomość e -mail do linku do resetowania hasła!',
            throttled: 'Poczekaj przed ponowną próbą.',
            token: 'Ten token resetowania hasła jest nieprawidłowy.',
            user: 'Nie możemy znaleźć użytkownika z tym adresem e -mail.',
        },
        pagination: {
            previous: '&laquo; poprzedni',
            next: 'Następny &raquo;',
        },
        dance_style: {
            saved_success: 'Styl tańca został uratowany.',
            deleted_success: 'Styl tańca został pomyślnie usunięty.',
            deleted_error: 'Błąd usuwania stylu tanecznego',
            not_found: 'Nie można było znaleźć stylu tanecznego.',
            parent_not_found: 'Nie można było znaleźć stylu tanecznego rodzica.',
            suggest_success: 'Wysłana sugestia stylu tańca.',
        },
        music_style: {
            saved_success: 'Styl muzyczny został uratowany.',
            deleted_success: 'Styl muzyczny został pomyślnie usunięty.',
            not_found: 'Nie można było znaleźć stylu muzycznego.',
            parent_not_found: 'Nie można było znaleźć stylu muzyki macierzystej.',
            suggest_success: 'Wysłana sugestia stylu muzycznego.',
        },
        invite: {
            sent: 'Wysłane zaproszenie',
            removed: 'Usunięto zaproszenie',
            resend_success: 'Zaproszenie urażone'
        },
        transfer_request: {
            already_owner: 'Jesteś już właścicielem tej organizacji.',
            organization_already_owns_event: 'Organizacja jest już właścicielem tego wydarzenia.',
        },
        transferlink: {
            removed: 'TransferLink został usunięty.'
        },
        user_block: {
            create_success: 'Blok użytkownika został pomyślnie utworzony.',
            update_success: 'Blok użytkownika został pomyślnie zaktualizowany.',
            delete_success: 'User block was successfully deleted.'
        },
    },
    favorites: {
        favorite: 'ulubiony',
        like: 'tak jak',
        login_required: 'Musisz zostać zalogowany, aby dodać to do swoich ulubionych.',
    },
    likes: {
        login_required: 'Musisz zostać zalogowany, aby dodać to do swoich upodobań.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'Nie można znaleźć użytkownika, aby utworzył tę organizację w imieniu.'
            }
        },
        on_behalf_of: {
            required: 'Wymagane jest w imieniu pola.',
        },
        required: 'to pole jest wymagane.',
        phone: {
            required: 'Numer telefonu jest wymagany.',
            regex: 'Numer telefonu jest nieprawidłowy.',
            length: 'Numer telefonu musi mieć co najmniej 10 cyfr.',
        },
        'phone number': {
            required: 'Numer telefonu jest wymagany.',
            regex: 'Numer telefonu jest nieprawidłowy.',
            'not-unique': 'Ten numer telefonu jest już używany.',
        },
        number: {
            required: 'wymagana jest liczba.',
            invalid: 'Liczba jest nieprawidłowa.'
        },
        email: {
            required: 'Wymagany jest adres e -mail.',
            invalid: 'Adres e -mail jest nieprawidłowy.',
            'not-unique': 'Adres e-mail nie jest unikalny.'
        },
        name: {
            required: 'Nazwa jest wymagana.',
            max_length: 'Nazwa jest zbyt długa.',
        },
        username: {
            required: 'Nazwa użytkownika jest wymagana.',
            invalid: 'Nazwa użytkownika jest nieprawidłowa.',
        },
        first_name: {
            required: 'Wymagane jest imię.',
        },
        last_name: {
            required: 'Nazwisko jest wymagane.',
        },
        gender: {
            required: 'Płeć jest wymagana'
        },
        city: {
            required: 'Miasto jest wymagane.',
        },
        street: {
            required: 'ulica jest wymagana.',
        },
        street_number: {
            required: 'Numer ulicy jest wymagany.',
        },
        country: {
            required: 'Kraj jest wymagany.',
        },
        brand: {
            required: 'Marka jest wymagana.'
        },
        short_description: {
            required: 'Wymagany jest krótki opis.',
        },
        long_description: {
            required: 'Wymagany jest długi opis.',
        },
        description: {
            required: 'Opis jest wymagany.',
        },
        type: {
            required: 'Wymagany jest typ.',
        },
        message: {
            required: 'Wiadomość jest wymagana.',
        },
        date_of_birth: {
            required: 'Wymagana jest data urodzenia.',
            regex: 'Data urodzenia jest nieważna.',
            age: 'Musisz mieć co najmniej 18 lat.',
            old: 'Musisz mieć co najwyżej 120 lat.'
        },
        date: {
            required: 'Data jest wymagana.',
            regex: 'Data jest nieprawidłowa.',
        },
        postal_code: {
            required: 'Kod pocztowy jest wymagany.',
            length: 'Kod pocztowy musi mieć co najmniej 4 cyfry.',
        },
        entrance: {
            required: 'Podanie ceny biletu jest obowiązkowe.',
        },
        repeat: {
            required: 'Powtórzenie jest wymagane.',
        },
        password: {
            required: 'Wymagane jest hasło.',
            regex: 'Wymagane prawidłowe hasło.',
            confirmed: 'Potwierdzenie hasła nie pasuje.',
            mismatch: 'Hasło nie pasuje.',
        },
        conditions: {
            required: 'Musisz zaakceptować warunki.',
        },
        url: {
            required: 'URL jest wymagany.',
            regex: 'URL jest nieprawidłowy.',
        },
        event_category: {
            required: 'Wymagany jest typ zdarzenia.',
        },
        language_code: {
            required: 'język jest wymagany.',
        },
        timezone: {
            required: 'Podanie strefy czasowej jest wymagane.',
        },
        is_public: {
            required: 'Widoczność jest wymagana.',
        },
        form_subject: {
            required: 'Temat jest wymagany.',
        },
        starts_at: {
            required: 'Data rozpoczęcia jest wymagana.',
            regex: 'Data rozpoczęcia jest nieprawidłowa.',
        },
        start_date: {
            required: 'Data rozpoczęcia jest wymagana.',
            regex: 'Data rozpoczęcia jest nieprawidłowa.',
            after_end_date: "Data rozpoczęcia musi być przed datą zakończenia.",
        },
        start_time: {
            required: 'Wymagany jest czas rozpoczęcia.',
            regex: 'Czas rozpoczęcia jest nieprawidłowy.',
        },
        end_date: {
            required: 'Data zakończenia jest wymagana.',
            regex: 'Data zakończenia jest nieprawidłowa.',
            before_start_date: "Data zakończenia musi być po dniu rozpoczęcia.",
        },
        end_time: {
            required: 'Wymagany jest czas zakończenia.',
            regex: 'Czas zakończenia jest nieprawidłowy.',
        },
        ends_at: {
            required: 'Data zakończenia jest wymagana.',
            regex: 'Data zakończenia jest nieprawidłowa.',
            before_start_date: "Data zakończenia musi być po dniu rozpoczęcia.",
        },
        registration_opens_at: {
            required: 'Wymagana jest data rozpoczęcia rejestracji.',
            regex: 'Data rozpoczęcia rejestracji jest nieprawidłowa.',
        },
        registration_closes_at: {
            required: 'Wymagana jest data zakończenia rejestracji.',
            regex: 'Data zakończenia rejestracji jest nieprawidłowa.',
        },
        location_type: {
            required: 'Wymagany jest typ lokalizacji.',
        },
        location_name: {
            required: 'Nazwa lokalizacji jest wymagana.',
        },
        dance_styles: {
            required: 'Wymagane są style tańca.',
        },
        music_styles: {
            required: 'Wymagane są style muzyki.',
        },
        photos: {
            required: 'Wymagane jest dołączenie co najmniej jednego zdjęcia.',
        },
        status: {
            required: 'Status jest wymagany.',
        },
        string: {
            required: '{fieldname} jest wymagane.',
            mismatch: '"{input}" nie pasuje "{safeword}".',
        },
        role: {
            required: 'Rola jest wymagana.',
        },
        favorite: {
            required: 'Ulubiony jest wymagany.',
        },
        dance_style: {
            required: 'Wymagany jest styl tańca.',
        },
        facebook: {
            required: 'Link na Facebooku jest wymagany.',
            regex: 'Wprowadź ważny link na Facebooku.',
        },
        facebook_event: {
            required: 'Link do wydarzenia na Facebooku jest wymagany.',
            regex: 'Wprowadź URL wydarzenia na Facebooku — musi wskazywać na facebook.com/events/{id}.',
        },
        instagram: {
            required: 'Wymagany jest link Instagram.',
            regex: 'Wprowadź prawidłowy link na Instagramie.',
        },
        website: {
            required: 'Link do strony jest wymagany.',
            regex: 'Wprowadź ważny link do strony.',
        },
        twitter: {
            required: 'Wymagany jest link X.',
            regex: 'Wprowadź prawidłowy link x.',
        },
        linkedin: {
            required: 'Wymagany jest link LinkedIn.',
            regex: 'Wprowadź prawidłowy link LinkedIn.',
        },
        youtube: {
            required: 'Wymagany jest link YouTube.',
            regex: 'Wprowadź ważny link YouTube.',
        },
        spotify: {
            required: 'Wymagany jest link Spotify.',
            invalid: 'Wprowadź prawidłowy link Spotify we właściwym formacie.',
            regex: 'Wprowadź prawidłowy link Spotify we właściwym formacie.',
        },
        soundcloud: {
            required: 'Wymagany jest link SoundCloud.',
            invalid: 'Wprowadź prawidłowy link SoundCloud we właściwym formacie.',
            regex: 'Wprowadź prawidłowy link SoundCloud we właściwym formacie.',
        },
        doesnt_exist: {
            email: 'Dostarczany adres e -mail nie istnieje.',
            user: 'dostarczony użytkownik nie istnieje.',
        },
        djs: {
            required: 'DJ -ie są wymagane.',
        },
        artists: {
            required: 'Artyści są wymagani.',
        },
        reason: {
            required: 'Powód jest wymagany.'
        },
        default: {
            doesnt_exist: {
                email: 'Dostarczany adres e -mail nie istnieje.',
                user: 'dostarczony użytkownik nie istnieje.',
            }
        }
    },
    brand_activity: {
        by_brand: 'użytkownik marki',
        by_admin: 'admin/scraping',
        export: 'Eksportuj CSV',
    },
    paginatable: {
        headers: {
            last_event_at: 'Ostatnia aktywność wydarzenia',
            last_event_by: 'Ostatnie wydarzenie przez',
            has_upcoming: 'Nadchodzące opublikowane',
            id: 'id',
            brand_id: 'identyfikator marki',
            title: 'tytuł',
            slug: 'ślimak',
            group: 'grupa',
            email: 'e-mail',
            phone: 'numer telefonu',
            name: 'nazwa',
            first_name: 'imię',
            last_name: 'nazwisko',
            role_name: 'rola',
            role: 'rola',
            report: 'Raport',
            created_at_formatted: 'utworzony w',
            status: 'status',
            actions: 'działania',
            type: 'typ',
            to_user_email: 'Do e-mail',
            from_user_email: 'Z e-mail',
            reason: 'powód',
            organization_name: 'Nazwa organizacji',
            organization_created: 'Organizacja stworzona',
            organization_updated: 'Organizacja ostatnia aktualizacja',
            confirmed_at: 'potwierdzone w',
            organization_role: 'rola',
            sub_dance_styles: 'Style Sub Dance',
            sub_music_styles: 'STYLE SUB MUZYKA',
            city: 'miasto',
            created_at: 'stworzony',
            updated_at: 'zmodyfikowane',
            is_favorite: 'ulubiony',
            starts_at: 'zaczyna się od',
            tickets_sold: 'Bilety sprzedane',
            price: 'cena',
            start_date: 'Data rozpoczęcia',
            is_public: 'publiczny',
            available_tickets: 'dostępne bilety',
            user_id: 'identyfikator użytkownika',
            transferable_type: 'typ',
            content_name: 'tytuł',
            paynl_transaction_id: 'Transakcja Paynl',
            date: 'Data zakupu',
            amount: 'Całkowita kwota',
            tax_amount: 'podatek',
            currency: 'waluta',
            description: 'opis',
            valid_from: 'Start',
            valid_until: 'wygaśnięcie',
            items: 'rzeczy',
            total: 'całkowity',
            featured: 'wyróżniony',
            created_by: 'użytkownik',
            location_type: 'Location type',
            category_id: 'kategoria',
            organization_category_id: 'kategoria',
            country_code: 'Kodeks kraju',
            location: 'lokalizacja',
            info: 'Informacje o użytkowniku',
            owner: 'reprezentujący',
            adres: 'adres',
            export_created: 'Utworzony eksport',
            image_path: "Ścieżka do obrazu",
            order_by: "Sortuj według",
            visibility: "Widoczność",
            image_alt: "Tekst alternatywny",
            image_title: "Tytuł obrazu",
            image: "Obraz",
            public_status: "Status publiczny",
            country: 'Kraj',
            activity: 'Aktywność',
        },
        search: 'szukaj',
        no_records: 'Nie znaleziono żadnych wyników',
    },
    pages: {
        related: 'Powiązane strony',
        contact: {
            title: 'Skontaktuj się z LatinMap',
            body: 'W przypadku pytań związanych z wydarzeniami prosimy o kontakt z organizacją, która opublikowała wydarzenie.'
        },
        'how-it-works': {
            title: 'Jak to działa',
            body: '<p> Sprzedaż biletów online za pośrednictwem LatinMap.com </p><p> Oferujemy organizacjom możliwość sprzedaży biletów online.'
        },
        'goods-and-services': {
            title: 'towary i usługi',
            body: '<p> Latinmap.com: Odkryj i doświadcz latynoskiego świata tańca </p><p> Witamy w Latinmap.com, miejscu, w którym bez wysiłku uzyskasz dostęp do najbardziej ekscytujących wydarzeń i doświadczeń w świecie tańca łacińskiego.'
        },
        'terms-and-conditions': {
            title: 'Warunki',
            body: '<p>20230529 Warunki sprzedaży biletów</p><p>1. Definicje</p><p>Terminy zdefiniowane tutaj z wielką literą na początku mają następujące znaczenie w niniejszych Warunkach:<br/>a. Warunki: niniejsze ogólne warunki sprzedaży biletów Fundacji LatinMap.com<br/>b. Wydarzenie: zorganizowane wydarzenie, takie jak wydarzenie o charakterze muzycznym, kulturalnym, sportowym i/lub rekreacyjnym, na które Fundacja LatinMap.com sprzedaje bilety<br/>c. Organizator wydarzenia: osoba fizyczna lub prawna, która produkuje lub organizuje wydarzenie i ponosi za nie odpowiedzialność<br/>d. Klient: osoba fizyczna lub prawna, która zawiera umowę z Fundacją LatinMap.com dotyczącą wydarzenia lub której Fundacja LatinMap.com składa ofertę zrobienia tego<br/>e. Umowa: umowa pomiędzy Fundacją LatinMap.com a Klientem w sprawie nabycia biletów na wydarzenia<br/>f. Bilet: dokument, który służy jako bilet wstępu na Wydarzenie, w tym bilety elektroniczne</p><p>2. Zastosowanie</p><p>a. Niniejsze Warunki mają zastosowanie do wszystkich ofert, zamówień, stosunków prawnych i umów, w ramach których Fundacja LatinMap.com dostarcza produkty lub usługi dowolnego rodzaju Klientowi, nawet jeśli te produkty lub usługi nie są (dalej) opisane w niniejszych Warunkach.<br/>b. Fundacja LatinMap.com wyraźnie odrzuca zastosowanie jakichkolwiek innych warunków Klienta.<br/>c. Strony mogą uzgodnić odstępstwa od Warunków wyłącznie w formie pisemnej. Fundacja LatinMap.com ma prawo do zmiany Warunków i Postanowień oraz do ogłoszenia zmienionych ogólnych warunków mających zastosowanie do Umów. Zmienione ogólne warunki można zapoznać się na stronie internetowej Fundacji LatinMap.com. d. Umowa podlega ogólnym warunkom Organizatora Wydarzenia. Jeżeli nie są już w posiadaniu Klienta, Organizator Wydarzenia prześle Klientowi ogólne warunki Organizatora Wydarzenia na jego żądanie.</p><p>3. Zawarcie Umowy</p><p>a. O ile nie uzgodniono inaczej na piśmie, wszystkie oferty, w tym reklamy i cenniki wymienione na stronie internetowej Fundacji LatinMap.com, są niezobowiązujące. b. Oferując i sprzedając Bilety, Fundacja LatinMap.com działa jako mediator w zawarciu Umowy między Kupującym a Organizatorem Wydarzenia. Fundacja LatinMap.com nie jest stroną Umowy, która zostaje zawarta poprzez zakup Biletu. Umowa zostaje zawarta po zakupie przez Klienta jednego lub większej liczby Biletów za pośrednictwem Fundacji LatinMap.com. Fundacja LatinMap.com dostarcza Bilety w imieniu Organizatora Wydarzenia.<br/>c. Przed potwierdzeniem rezerwacji Klient musi zawsze sprawdzić, czy zarezerwowano właściwe Bilety. Dokonując rezerwacji, Klient musi zawsze używać prawidłowego adresu (e-mail). Jeśli Klient zdecyduje się na otrzymywanie Biletów drogą elektroniczną, ryzyko utraty, kradzieży lub niewłaściwego użycia Biletu spoczywa na Kliencie od momentu dotarcia Biletów do niego. Jeśli istnieją wątpliwości co do dokładności danych wprowadzonych przez Klienta podczas składania zamówienia, Fundacja LatinMap.com może skontaktować się z Klientem, korzystając z danych wprowadzonych przez Klienta. Jeśli Fundacja LatinMap.com nie może skontaktować się z Klientem i w związku z tym nie może zweryfikować danych, Fundacja LatinMap.com może anulować rezerwację i sprzedać Bilety innemu Klientowi. Jeśli Fundacja LatinMap.com ma wątpliwości co do dokładności lub ważności danych wprowadzonych przez Klienta podczas składania zamówienia lub metody płatności użytej przez Klienta, ma prawo anulować rezerwację Klienta i sprzedać Bilety innemu Klientowi. Fundacja LatinMap.com dołoży wszelkich starań, aby poinformować Klienta w takim przypadku. Każda Umowa jest zawierana pod warunkiem zawieszającym wystarczającej dostępności odpowiednich produktów lub usług.<br/>d. Fundacja LatinMap.com i/lub Organizator Wydarzenia zastrzegają sobie prawo do ustalenia maksymalnej liczby Biletów, które można zarezerwować/zakupić. Jeśli Klient przekroczy tę maksymalną liczbę, Fundacja LatinMap.com i/lub Organizator Wydarzenia mają prawo anulować rezerwację Biletów powyżej maksymalnej liczby lub unieważnić dane Bilety.<br/>e. Biletów nie można zwrócić. Do biletów stosuje się postanowienia artykułu 6:230p sub e BW.</p><p>4. Ceny i płatność</p><p>a. Fundacja LatinMap.com sprzedaje bilety w imieniu organizatorów wydarzeń, którzy ustalają cenę i liczbę dostępnych miejsc. Informacje dotyczące ceny i dostępności są podawane bez zobowiązań i mogą ulec zmianie.<br/>b. Klient płaci za produkty lub usługi zamówione za pośrednictwem strony internetowej, cena podana w Umowie. Płatność jest dokonywana w sposób wskazany na stronie internetowej Fundacji LatinMap.com. Do zamówienia mogą być stosowane dodatkowe warunki (płatności/zamówienia).</p><p>c. Wszystkie ceny Fundacji LatinMap.com podane na stronie internetowej są w euro, w tym VAT, chyba że wyraźnie wskazano inaczej.<br/>d. Fundacja LatinMap.com pobiera opłaty za obsługę za każde zamówienie. Ponadto Fundacja LatinMap.com pobiera opłaty administracyjne obliczane na podstawie całkowitej kwoty transakcji.</p><p>e. Jeśli Klient nie zapłaci należnych kwot w terminie, Klient jest zobowiązany, bez potrzeby jakiegokolwiek wezwania lub zawiadomienia o zaległości, do zapłaty odsetek ustawowych od zaległej kwoty. Jeżeli Klient nadal nie dopełni obowiązku uregulowania roszczenia po otrzymaniu żądania lub zawiadomienia o niewykonaniu zobowiązania, Fundacja LatinMap.com może przekazać roszczenie, w takim przypadku Klient zobowiązany jest również do zwrotu wszelkich kosztów sądowych i pozasądowych, w tym kosztów obliczonych przez zewnętrznych ekspertów, oprócz kosztów ustalonych prawnie.</p><p>5. Terminy dostawy</p><p>a. Bilety są wysyłane na adres (e-mail) podany przez Klienta w momencie składania zamówienia. Fundacja LatinMap.com będzie nadal uważać adres (e-mail) podany przez Klienta za poprawny, dopóki Klient nie powiadomi Fundacji LatinMap.com o nowym adresie (e-mail). b. Terminy dostawy podane przez Fundację LatinMap.com nigdy nie będą uważane za ścisły termin, chyba że wyraźnie uzgodniono inaczej. W przypadku nieterminowej dostawy Fundacja LatinMap.com musi otrzymać pisemne zawiadomienie o niewykonaniu zobowiązania.</p><p>c. Przekroczenie jakiegokolwiek terminu dostawy nie uprawnia Klienta do odszkodowania ani prawa do anulowania zamówienia lub rozwiązania Umowy, chyba że termin dostawy został przekroczony w takim stopniu, że nierozsądne jest oczekiwanie od Klienta dotrzymania Umowy.</p><p>d. Z wyjątkiem opcji zamówienia biletów elektronicznych, sprzedaż biletów za pośrednictwem strony internetowej i centrum telefonicznego zostaje wstrzymana na 8 dni przed datą Wydarzenia, aby dać Fundacji LatinMap.com możliwość wysłania biletów pocztą.</p><p> 6. Odwołane i przełożone Wydarzenia </p><p> a. Klient jest odpowiedzialny za sprawdzenie, czy Wydarzenie zostało odwołane lub przełożone oraz jaka będzie nowa godzina lub lokalizacja. Chociaż Stichting LatinMap.com podejmie próbę powiadomienia Klienta o anulowaniu po otrzymaniu niezbędnych informacji od Organizatora Wydarzenia, Stichting LatinMap.com nie może zagwarantować, że Klient zostanie powiadomiony o anulowaniu przed datą Wydarzenia.</p><p> b. Stichting LatinMap.com nie ponosi odpowiedzialności za poniesione koszty.<br/>c. Bilety na przełożone Wydarzenia zazwyczaj pozostają ważne na Wydarzenie zastępcze. Aby uzyskać więcej informacji na ten temat, Klient może skontaktować się ze Stichting LatinMap.com za pośrednictwem naszego adresu e-mail: mail(at)LatinMap.com. Jeśli Wydarzenie zostanie przeniesione w inne miejsce lub na inną datę, Organizator Wydarzenia może narzucić warunki zwrotu ceny biletu.<br/>d. Jeśli Wydarzenie zostanie odwołane lub przełożone, Klient może zwrócić Bilety na to Wydarzenie zgodnie z ustaleniami ustalonymi przez Organizatora Wydarzenia. W celu zapoznania się z odpowiednimi warunkami odsyłamy do Ogólnych Warunków i Postanowień organizatora wydarzenia. Jeśli Organizator Wydarzenia zażąda od Stichting LatinMap.com zwrotu ceny biletu Klientowi, Stichting LatinMap.com zrobi to po otrzymaniu odpowiednich środków od Organizatora Wydarzenia. Opłaty za usługi i administrację nie podlegają zwrotowi. </p><p> 7. Bilety </p><p> a. Bilety dystrybuowane przez Stichting LatinMap.com pozostają własnością Organizatora Wydarzenia. Klient nie ma prawa odsprzedawać Biletu, jeśli narusza to prawo. Ponadto Organizator Wydarzenia może zakazać odsprzedaży lub komercyjnego wykorzystania Biletu. Klient powinien to sprawdzić w ogólnych warunkach organizatora, do których odniesiono się na Bilecie (oraz podczas procesu zamawiania). W przypadku (próby) odsprzedaży lub komercyjnego wykorzystania z naruszeniem prawa lub warunków Organizatora Wydarzenia, Organizator Wydarzenia ma prawo unieważnić odpowiedni Bilet i/lub nałożyć na Klienta grzywnę. Posiadaczom nieważnych przepustek wstępu zostanie odmówiony dostęp do Wydarzenia, bez prawa do odszkodowania.<br/>b. Po otrzymaniu Klient musi sprawdzić Bilety, ponieważ błędy nie zawsze mogą zostać naprawione. Po zakupie Biletów nie można wymienić ani zwrócić.<br/>c. Jeśli Bilet Klienta jest tak uszkodzony, że nie można już zweryfikować jego autentyczności, Klient może skontaktować się z obsługą klienta online.<br/>d. Specjalne prośby, takie jak rezerwacja miejsc dla wózków inwalidzkich, muszą zostać zgłoszone w odpowiednim czasie i w sposób wyraźny. Stichting LatinMap.com nie może zagwarantować, że specjalne prośby zostaną uwzględnione. Aby uzyskać więcej informacji na ten temat, Klient może skontaktować się ze Stichting LatinMap.com za pośrednictwem naszego adresu e-mail: mail(at)LatinMap.com </p><p> 8. Prawa własności intelektualnej i przemysłowej </p><p> a. Prawa własności przemysłowej i intelektualnej spoczywające na Bilecie od Stichting LatinMap.com należą do Stichting LatinMap.com lub jego licencjodawcy. Klient powstrzyma się od wszelkich działań, które mogłyby naruszyć prawa lub inne interesy Stichting LatinMap.com lub jego licencjodawcy.<br/>b. Klientowi nie wolno usuwać ani zmieniać żadnych oznaczeń praw autorskich, znaków towarowych, nazw handlowych ani innych praw własności intelektualnej lub przemysłowej z Biletu, ani dokonywać żadnych zmian w formie lub jakiejkolwiek innej charakterystyce Biletu.<br/>c. Klientowi zabrania się fałszowania, powielania lub reprodukowania Biletu w jakikolwiek sposób.<br/>d. Umowa nie obejmuje przeniesienia jakichkolwiek praw własności intelektualnej ze Stichting LatinMap.com na Klienta. </p><p> 9. Prywatność </p><p> a. Dane dostarczone przez Klienta podczas zakupu biletów będą wykorzystywane wyłącznie przez Stichting LatinMap.com w celu ulepszenia swoich usług.<br/>b. Dane dostarczone przez Klienta podczas zakupu biletów nigdy nie będą udostępniane osobom trzecim. </p><p> c. Dane dostarczone przez Klienta podczas zakupu biletów będą dostępne dla Organizacji sprzedającej. Istnieje możliwość, że Organizacja wykorzysta te dane do wysyłania mailingów.<br/>d. Oczekujemy, że nasi klienci będą obchodzić się z tymi informacjami ostrożnie. Jeśli tak nie jest, chcielibyśmy o tym usłyszeć i powiadomimy o tym odpowiedniego klienta, a jeśli uznamy to za konieczne, wykluczymy klienta ze sprzedaży biletów online. </p><p> e. Uwaga: nie ponosimy odpowiedzialności za politykę prywatności naszych klientów. </p><p> 10. Odpowiedzialność </p><p> a. Stichting LatinMap.com nie może być uznawana za organizatora (Organizatora wydarzenia) Wydarzenia i nie ponosi odpowiedzialności ani nie gwarantuje (artystycznej) jakości i treści Wydarzenia oraz przebiegu wydarzeń w ramach Wydarzenia lub wokół niego, i nie przyjmuje żadnej odpowiedzialności na tej podstawie. </p><p> b. Z wyjątkiem innych postanowień dotyczących odpowiedzialności zawartych w niniejszych Ogólnych Warunkach, całkowita odpowiedzialność Stichting LatinMap.com z tytułu przypisywalnego niewykonania lub z powodu czynu niedozwolonego ogranicza się do odszkodowania za bezpośrednie szkody do kwoty nie wyższej niż kwota, która została lub może zostać naliczona Klientowi za Bilety, chyba że szkoda jest wynikiem umyślnego działania i/lub rażącego niedbalstwa </p><p> Stichting LatinMap.com lub jego podmiotów podrzędnych.<br/> c. Odpowiedzialność Stichting LatinMap.com z tytułu przypisywalnego niewykonania umowy powstaje wyłącznie w przypadku, gdy Klient niezwłocznie i prawidłowo zgłosi Stichting LatinMap.com niewykonanie zobowiązania na piśmie, wyznaczając rozsądny termin naprawy niewykonania zobowiązania, a Stichting LatinMap.com również po upływie tego terminu nadal nie wywiązuje się ze swoich zobowiązań. Zawiadomienie o niewykonaniu zobowiązania musi zawierać opis niewykonania zobowiązania, który jest możliwie najpełniejszy i najbardziej szczegółowy, aby Stichting LatinMap.com mogło odpowiednio zareagować.<br/> d. Klient zwalnia Stichting LatinMap.com z odpowiedzialności za wszelkie roszczenia osób trzecich związane z niewykonaniem zobowiązania przez Klienta lub niewystarczającym wykonaniem zobowiązania wobec Stichting LatinMap.com, niezależnie od tego, czy wynika ono z Ogólnych Warunków.<br/> e. Warunkiem istnienia prawa do odszkodowania jest zawsze zgłoszenie szkody Stichting LatinMap.com na piśmie tak szybko, jak to możliwe po jej wystąpieniu. f. Stichting LatinMap.com nigdy nie ponosi odpowiedzialności za jakąkolwiek formę uszkodzenia lub utraty Biletu. W przypadku utraty lub kradzieży Klient nie może ubiegać się o Bilet zastępczy ani o zwrot środków. Stichting LatinMap.com nie ponosi również odpowiedzialności za opóźnienia lub niedostarczenie lub nieprawidłowe dostarczenie Biletów, jeśli opóźnienie, niedostarczenie lub nieprawidłowe dostarczenie nie może być przypisane Stichting LatinMap.com.<br/> g. Stichting LatinMap.com nie ponosi żadnej odpowiedzialności za Bilety uzyskane od osób trzecich przez Klienta. Stichting LatinMap.com nie może również zagwarantować ich autentyczności.<br/> h. Stichting LatinMap.com w żaden sposób nie ponosi odpowiedzialności za jakiekolwiek szkody poniesione przez posiadacza tego biletu wstępu z powodu działań lub zaniechań osób trzecich. </p><p> 11. Siła wyższa </p><p> a. Przez siłę wyższą rozumie się każdą awarię, której nie można przypisać Stichting LatinMap.com, ponieważ nie wynika ona z jej winy i nie leży w jej gestii ani na mocy prawa, aktu prawnego, ani według powszechnie przyjętych standardów.<br/> b. Bez uszczerbku dla swoich innych praw, Stichting LatinMap.com ma prawo zawiesić realizację zamówienia Klienta w przypadku wystąpienia siły wyższej, powiadamiając o tym Klienta na piśmie, bez obowiązku Stichting LatinMap.com do jakiegokolwiek odszkodowania, chyba że byłoby to niedopuszczalne według standardów rozsądku i uczciwości w danych okolicznościach. </p><p> 12. Obowiązujące prawo i właściwy sąd </p><p> a. Wszystkie umowy ze Stichting LatinMap.com podlegają prawu holenderskiemu. </p><p> 13. Różne </p><p> a. Klienci, którzy spóźnią się na Wydarzenie, zostaną wpuszczeni - o ile to możliwe - w odpowiednich momentach Wydarzenia. Jednak wstęp nie może być zagwarantowany.<br/> b. W przypadku gdy niniejsze Ogólne Warunki zobowiązują Stichting LatinMap.com do pisemnej komunikacji, Stichting LatinMap.com ma prawo do dokonania tej komunikacji drogą elektroniczną, taką jak, ale nie wyłącznie, wiadomość e-mail lub faks.<br/> c. Oczywiste pomyłki i literówki na stronie internetowej Stichting LatinMap.com lub w ofertach, potwierdzeniach zamówień, biletach i/lub innych dokumentach nie wiążą Stichting LatinMap.com. d. W przypadku braku porozumienia między Stichting LatinMap.com a Klientem w kwestii tłumaczenia i/lub interpretacji Ogólnych Warunków, decydująca będzie wersja holenderska.<br/> e. Jeżeli jedno lub więcej postanowień niniejszych Ogólnych Warunków lub jakiejkolwiek innej umowy ze Stichting LatinMap.com będzie sprzeczne z jakimkolwiek obowiązującym wymogiem prawnym, odpowiednie postanowienie będzie nieważne i zastąpione nowym prawnie dopuszczalnym porównywalnym postanowieniem, które zostanie określone przez Stichting LatinMap.com. </p>'
        },
        'privacy-policy': {
            title: 'Polityka prywatności',
            body: '<p> Polityka prywatności dla Latinmap.com: Odkryj i doświadcz latynoskiego świata tańca <br> Ostatnia aktualizacja: 23-05-2023 <br> Dziękujemy za wizytę w Latinmap.com, miejscu do odkrywania i doświadczenia świata tańca łacińskiego.'
        },
        about: {
            'about-latin-scene': {
                title: "o scenie łacińskiej",
                body: "Łacińska scena tańca to żywa i różnorodna społeczność, która celebruje bogate dziedzictwo kulturowe Ameryki Łacińskiej poprzez muzykę, taniec i sztukę."
            },
            salsa: {
                title: "salsa",
                body: "Salsa to popularna forma tańca społecznego, która powstała na Karaibach."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata to gatunek muzyki latynoamerykańskiej, który powstał w Dominikanie w pierwszej połowie XX wieku z elementami muzycznymi europejskimi, rdzennymi i afrykańskimi."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk to szybki karnawałowy styl muzyki rytmicznej pochodzącej z Karaibskich Wysp Gwadelupy i Martyki, spopularyzowanej przez francuskie antylles Kassav \'w latach 80."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba to gatunek muzyczny i styl tańca pochodzący z Angoli na przełomie lat siedemdziesiątych i lat 80."
            },
            cuban: {
                title: "kubański",
                body: "Kubańska muzyka i taniec są głęboko zakorzenione w różnorodnym dziedzictwie kulturowym wyspy, mieszaniu wpływów afrykańskich, hiszpańskich i tubylczych."
            }
        },
        'help-center-faq': {
            title: 'Pomoc i wsparcie',
        },
        'cookie-policy': {
            title: 'Polityka plików cookie',
        },
        'create-an-event': {
            title: 'Jak utworzyć wydarzenie',
        },
        'create-an-brand-or-an-organization': {
            title: 'Jak stworzyć markę',
        },
        'become-an-ambassador': {
            title: 'Zostań ambasadorem',
        },
        'promote-your-event': {
            title: 'Jak promować swoje wydarzenie',
        },
        'professional-account-verification': {
            title: 'Weryfikacja konta profesjonalnego'
        },
        'about-us': {
            title: 'O nas',
        },
    },
    email: {
        'not-unique': 'E -mail został już pobrany.',
    },
    leads: {
        title: 'Prześlij ołów',
        plural: 'wskazówki',
        type: {
            event: 'wydarzenie',
            organization: 'organizacja',
            label: 'typ',
        },
        name: 'nazwa',
        address: 'adres',
        country: 'kraj',
        city: 'miasto',
        street: 'ulica',
        street_number: 'numer ulicy',
        dance_styles: 'Style tańca',
        music_styles: 'Style muzyczne',
        photos: 'Zdjęcia',
        category: 'Typ zdarzenia',
        location_name: 'Nazwa miejsca',
        location_type: {
            singular: 'Typ lokalizacji',
            online: 'faktyczny',
            offline: 'osobiście',
        },
        timezone: 'strefa czasowa',
        date: 'data',
        not_posted_by_ambassador: 'zweryfikowane przez organizatora',
        undercondition: 'pod warunkiem',
        warning: 'ważna zmiana',
        cancelled: 'odwołany',
        posted_by_ambassador: 'Wysłane przez Ambasador Latinmap',
        upcoming: 'Nadchodzące wydarzenia',
        status_options: {
            active: 'aktywny',
            canceled: 'odwołany',
            pending: 'Jeszcze nie potwierdzono',
            changed: 'ważna zmiana',
            submitted: 'złożony',
            under_review: 'w trakcie przeglądu',
            implemented: 'zaimplementowane',
            declined: 'odrzucony',
        },
        submit: 'składać',
        success: 'Ołów został złożony.',
        filter_type: 'Filtr według typu',
        view: 'Ołów',
        confirm_delete: 'usuń ołów',
        delete_confirmation: 'Czy na pewno chcesz usunąć ten potencjalny potencjał?',
        deleted_successfully: 'Ołów został pomyślnie usunięty.',
        error_loading: 'Olady ładowania błędów',
        status_updated: 'Status wiodący został zaktualizowany.',
        error_status: 'Błąd aktualizacji stanu wiodącego',
    },
    search: {
        allOragnisations: 'Zobacz wszystkie szkoły tańca',
        allEvents: 'Zobacz wszystkie wydarzenia',
        searchresult: 'Wyniki wyszukiwania',
        title: 'tytuł',
        type: 'Typ',
        city: 'miasto',
        country: 'kraj',
        address: 'adres',
        startdate: 'Data rozpoczęcia',
        favorite: 'ulubiony'
    },
    components: {
        picture_input: {
            drag: "Prześlij awatar",
            remove: 'Usuń awatar',
            change_avatar: 'Zmień awatara'
        },
        pictureInput: {
            drag: "Kliknij tutaj, aby przesłać zdjęcie",
            change: "Zmień",
            remove: "Usuń",
            upload: "Prześlij",
            tap: "Stuknij, aby przesłać",
            select: "Wybierz plik",
            selected: "Wybrano",
            fileSize: "Rozmiar pliku",
            fileType: "Typ pliku",
            aspect: "Proporcje"
        },
    },
    passion: {
        title: "Poczuj Rytm, Dołącz do Ruchu",
        subtitle: "Odkryj tętniący życiem świat tańca latynoamerykańskiego. Połącz się z tancerzami, znajdź wydarzenia w pobliżu i pozwól muzyce poruszyć Twoją duszę.",
    },
    payment: {
        received: "Otrzymana płatność",
        thank_you: "Dziękuję za zakup!",
        download_ticket: "Pobierz bilety (y)",
        download_button: "Pobierz bilety (y)",
        email_check: "Sprawdź swoją skrzynkę odbiorczą, w tym folder spamowy, aby uzyskać wiadomość e -mail z naszego systemu biletów.",
        failed: "w toku płatności",
        failed_message: "Niestety napotkaliśmy problem przetwarzający Twoją płatność.",
        download_invoice: "Pobierz fakturę",
        download_invoice_button: "Pobierz fakturę",
        invoice_check: "Sprawdź swoją skrzynkę odbiorczą dla swojej faktury.",
        thank_you_for_purchase: "Dziękujemy za zakup polecanego wydarzenia!",
    },
    financial_center: {
        financial_dashboard: 'mój pulpit finansowy',
        title: "Centrum finansowe",
        description: "Zarządzaj transakcjami, wypłatami, promocjami i funkcjami premium.",
        overview: "przegląd",
        transactions: "transakcje",
        payoutsettings: "Ustawienia wypłaty",
        featured_events: "Polecane wydarzenia",
        ticketsales: "Sprzedaż biletów",
        premium: "Konta premium",
    },
    inputfield: {
        select_here: 'Wybierz tutaj',
    },
    tooltip: {
        edit: 'redagować',
        delete: 'usuwać',
        view: 'pogląd',
        hide: 'ukrywać',
        under_construction: 'w budowie',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Coś poszło nie tak. Spróbuj ponownie za chwilę.",
        confirm: {
            title: "Nie chcesz tych e-maili?",
            body: "Otrzymujesz te automatyczne e-maile na adres {email}.",
            note: "Wiadomości dotyczące konta, na przykład reset hasła, nadal będziemy wysyłać.",
            button: "Zatrzymaj te e-maile",
        },
        done: {
            title: "Nie otrzymasz już nic",
            body: "Nie będziemy wysyłać automatycznych e-maili na {email}.",
            undo: "Chcę je znowu otrzymywać",
        },
        unknown: {
            title: "Ten link już nie działa",
            body: "Link jest nieprawidłowy. Użyj linku z nowszego e-maila.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Zgłoś wydarzenie',
        title: 'Wyślij swoje wydarzenie do LatinMap',
        title_brand: 'Zgłoś wydarzenie dla {brand}',
        lede: 'Wypełnij, co wiesz. Przygotujemy je i opublikujemy po krótkim sprawdzeniu.',
        loading: 'Chwileczkę…',
        notes: {
            no_account: 'Konto niepotrzebne — wystarczy ten link',
            checked: 'Sprawdzamy każde wydarzenie przed publikacją',
            reply: 'Jeśli coś będzie niejasne, napiszemy do Ciebie',
        },
        sections: {
            event: 'Wydarzenie',
            where: 'Gdzie',
            details: 'Szczegóły',
            you: 'O Tobie',
        },
        fields: {
            name: 'Nazwa wydarzenia',
            organizer_name: 'Nazwa organizatora / marki',
            organizer_url: 'Strona lub social media organizatora',
            start_date: 'Data',
            start_time: 'Godzina rozpoczęcia',
            end_date: 'Data zakończenia',
            end_time: 'Godzina zakończenia',
            dance_styles: 'Style tańca',
            event_category: "Rodzaj wydarzenia",
            event_category_placeholder: "Wybierz rodzaj wydarzenia",
            location_name: 'Miejsce',
            city: 'Miasto',
            country: 'Kraj',
            country_placeholder: 'Wybierz kraj',
            short_description: 'Krótki opis',
            description: 'Pełny opis',
            link: 'Link do informacji lub biletów',
            photo: "Zdjęcie",
            photo_remove: "Usuń zdjęcie",
            your_name: 'Twoje imię',
            your_email: 'Twój adres e-mail',
        },
        hints: {
            organizer: 'Kto organizuje to wydarzenie? Link do strony lub Instagrama pomoże nam znaleźć właściwą markę.',
            end_date: "W przypadku wydarzenia jednodniowego to ta sama data co początek.",
            contact: 'Używamy tego wyłącznie do kontaktu w sprawie tego wydarzenia.',
            photo: "Opcjonalnie. JPG, PNG lub WebP, maksymalnie 8 MB.",
        },
        errors: {
            name: 'Podaj nazwę wydarzenia.',
            start_date: 'Podaj datę.',
            end_date: "Podaj datę zakończenia.",
            event_category: "Wybierz rodzaj wydarzenia.",
            too_many: "Próbowałeś zbyt wiele razy. Odczekaj chwilę i spróbuj ponownie.",
            city: 'Podaj miasto.',
            country: 'Wybierz kraj.',
            organizer_name: 'Podaj, kto organizuje to wydarzenie.',
            email: 'Podaj poprawny adres e-mail.',
            failed: 'Wysyłka się nie powiodła. Spróbuj ponownie za chwilę.',
            photo_type: "Wybierz plik JPG, PNG lub WebP.",
            photo_size: "To zdjęcie jest za duże. Maksymalnie 8 MB.",
        },
        submit: 'Wyślij wydarzenie',
        done: {
            title: 'Dziękujemy, mamy Twoje wydarzenie',
            body: 'Ktoś z LatinMap je sprawdzi. Otrzymasz potwierdzenie e-mailem.',
            again: 'Zgłoś kolejne wydarzenie',
        },
        invalid: {
            title: 'Ten link już nie działa',
            body: 'Link wygasł lub został wycofany. Poproś o nowy.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Bądź blisko sceny',
            lede: 'Otrzymuj wydarzenia tańca latino, dla których warto zarezerwować wieczór — imprezy, festiwale, warsztaty i zajęcia próbne, a także nowości i konkursy od LatinMap.',
            benefits: {
                agenda: 'Kalendarz, wcześniej niż inni',
                festivals: 'Festiwale i kongresy warte podróży',
                features: 'Nowe funkcje LatinMap zaraz po premierze',
                community: 'Konkursy i wiadomości od społeczności',
            },
            form_title: 'Zapisz się',
            email_label: 'Twój adres e-mail',
            submit: 'Zapisz mnie',
            terms: 'Jedna wiadomość naraz, a Twój adres nigdy nie trafia do nikogo innego. Wypisz się jednym kliknięciem, w każdej wiadomości.',
            done: {
                title: 'Sprawdź swoją skrzynkę',
                body: 'Wysłaliśmy Ci jedną wiadomość. Kliknij link w środku, aby potwierdzić, i jesteś na liście.',
                again: 'Zapisz kolejny adres',
            },
        },
        confirmed: {
            title: 'Zapis potwierdzony',
            success: 'Twój zapis został potwierdzony. Witamy!',
            body: 'Od teraz będziesz otrzymywać newsletter LatinMap: najlepsze wydarzenia tańca latino prosto na Twoją skrzynkę. Możesz zrezygnować jednym kliknięciem w każdym newsletterze.',
            discover_events: 'Odkryj wydarzenia',
            back_home: 'Powrót na stronę główną',
        },
    },
    footer: {
        section_1: {
            title: 'Odkryj Latinmap',
            about: 'O nas',
            how_it_works: 'Jak to działa',
            search: 'Szukaj',
            contact: 'Skontaktuj się z nami',
        },
        section_2: {
            title: 'Wsparcie i społeczność',
            help: 'Centrum Pomocy i FAQ',
            privacy_policy: 'Polityka prywatnosci',
            terms_and_conditions: 'Warunki i regulaminy',
            cookie_policy: 'Polityka plików cookie',
        },
        section_3: {
            title: 'dla profesjonalistów',
            create_event: 'Jak utworzyć wydarzenie',
            create_organization: 'Jak stworzyć markę',
            become_ambassador: 'Zostań ambasadorem',
            promote_event: 'Jak promować swoje wydarzenie',
            professional_account_verification: 'Weryfikacja konta profesjonalnego'
        },
        section_4: {
            title: 'Kategorie Tańca i Wydarzeń',
            all_events: 'Alle Veranstaltungen',
        },
        follow_our_socials: 'Obserwuj nasze media społecznościowe',
    }
};
